import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Tabs,
  Tab,
  Button,
  Chip,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Divider,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  Snackbar,
  Alert,
  
} from '@mui/material';
import { formatCurrency, formatDate as formatDateUtil } from '../utils/format';
import { ensureLogin, fetchProjectById, fetchProjectActivities, fetchProjectRisks, fetchProjectTeam, fetchProjectReports, createReport, downloadReport, addProjectMember, updateProject, updateActivity, createActivity, deleteActivity, getApiHost, fetchUsers, listStorage, mkdirStorage, uploadStorage, deleteStorage, updateScheduleTask } from '../utils/api';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Gantt from 'frappe-gantt';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// CSS do frappe-gantt removido temporariamente para evitar erro de importação.

// Dados simulados removidos: utilizamos API real

const ProjectDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [activities, setActivities] = useState([]);
  const [risks, setRisks] = useState([]);
  const [team, setTeam] = useState([]);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [planningNotes, setPlanningNotes] = useState({});
  const [projectDraft, setProjectDraft] = useState({ scope: '', objectives: '', globalActivitiesDescription: '', globalActivitiesObjectives: '', globalActivitiesDuration: '', globalActivitiesDeliverables: '' });
  const [savingProject, setSavingProject] = useState(false);
  const [activityDrafts, setActivityDrafts] = useState({});
  const [savingActivityId, setSavingActivityId] = useState(null);
  const [newActivity, setNewActivity] = useState({ title: '', description: '', objectivesText: '', deliverablesText: '', startDate: '', endDate: '' });
  const [newActivityErrors, setNewActivityErrors] = useState({});
  const [creatingActivity, setCreatingActivity] = useState(false);
  const [isPlanningEditing, setIsPlanningEditing] = useState(false);
  const [scheduleTasks, setScheduleTasks] = useState([]);
  const [newTask, setNewTask] = useState({ name: '', responsible: '', startDate: '', endDate: '', status: 'planeado', budget: '', tecnicoOperacoesText: '', coordenadorTecnicoText: '', formadorConsultorText: '' });
  const [allUsers, setAllUsers] = useState([]);
  const [teamAssignments, setTeamAssignments] = useState({ tecnicoOperacoesText: '', coordenadorTecnicoText: '', formadorConsultorText: '' });
  const [validationErrors, setValidationErrors] = useState({});
  // Diálogos e estado para Tarefas do Cronograma
  const [viewTask, setViewTask] = useState(null);
  const [editTask, setEditTask] = useState(null);
  const [taskDraft, setTaskDraft] = useState({ name: '', responsible: '', startDate: '', endDate: '', status: 'planeado', budget: '', tecnicoOperacoesText: '', coordenadorTecnicoText: '', formadorConsultorText: '', notes: '' });
  const [outputsDraft, setOutputsDraft] = useState([]);
  const [outputsErrors, setOutputsErrors] = useState([]);
  const [taskEditErrors, setTaskEditErrors] = useState({ dateOrder: '' });
  const [newTaskErrors, setNewTaskErrors] = useState({ dateOrder: '' });
  // Notas inline na tab Execução
  const [executionNotes, setExecutionNotes] = useState({});
  // Toggle de pré-visualização por tarefa na Execução
  const [showAttachmentPreviews, setShowAttachmentPreviews] = useState({});
  const [deletingTaskId, setDeletingTaskId] = useState(null);
  const [ganttFullscreenOpen, setGanttFullscreenOpen] = useState(false);
  const location = useLocation();
  // Diálogos de ver/editar e estado de apagar
  const [viewActivity, setViewActivity] = useState(null);
  const [editActivity, setEditActivity] = useState(null);
  const [editDraft, setEditDraft] = useState({ title: '', startDate: '', endDate: '', description: '', objectivesText: '', tasksText: '', deliverablesText: '' });
  const [deletingActivityId, setDeletingActivityId] = useState(null);
  // Gantt
  const [ganttViewMode, setGanttViewMode] = useState('Week');
  const ganttContainerRef = useRef(null);
  const ganttInstanceRef = useRef(null);
  const [ganttShowOutputs, setGanttShowOutputs] = useState(true);
  const [ganttStatusFilter, setGanttStatusFilter] = useState('__all__');
  const [ganttHiddenIds, setGanttHiddenIds] = useState(new Set());
  const [ganttSearchText, setGanttSearchText] = useState('');
  const [ganttDateRange, setGanttDateRange] = useState({ start: '', end: '' });
  const [ganttResponsibleFilter, setGanttResponsibleFilter] = useState('');
  const [ganttAssignedToFilter, setGanttAssignedToFilter] = useState('');
  const [ganttError, setGanttError] = useState('');
  const [outputsSort, setOutputsSort] = useState('date');
  const [documentsSort, setDocumentsSort] = useState('date');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [ganttPlannedMin, setGanttPlannedMin] = useState('');
  const [ganttPlannedMax, setGanttPlannedMax] = useState('');
  const [ganttRealMin, setGanttRealMin] = useState('');
  const [ganttRealMax, setGanttRealMax] = useState('');
  const [ganttOutputStateFilter, setGanttOutputStateFilter] = useState('__all__');
  // Snapshots para detetar alterações (dirty state)
  const [originalProjectDraft, setOriginalProjectDraft] = useState({ scope: '', objectives: '', globalActivitiesDescription: '', globalActivitiesObjectives: '', globalActivitiesDuration: '', globalActivitiesDeliverables: '' });
  const [originalScheduleTasks, setOriginalScheduleTasks] = useState([]);
  const [originalTeamAssignments, setOriginalTeamAssignments] = useState({ tecnicoOperacoesText: '', coordenadorTecnicoText: '', formadorConsultorText: '' });

  // Removido: abertura automática de Templates via query param

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await ensureLogin();
      try {
        const projectId = parseInt(id);
        const [p, acts, rks, tm, reps] = await Promise.all([
          fetchProjectById(projectId),
          fetchProjectActivities(projectId),
          fetchProjectRisks(projectId),
          fetchProjectTeam(projectId),
          fetchProjectReports(projectId)
        ]);
        setProject(p || null);
        setActivities(Array.isArray(acts) ? acts : []);
        setRisks(Array.isArray(rks) ? rks : []);
        setTeam(Array.isArray(tm) ? tm : []);
        setReports(Array.isArray(reps) ? reps : []);
        // Removido: flags de Kick-off não são usadas no dashboard
      } catch (err) {
        console.error('Erro a carregar detalhes do projeto:', err);
        setProject(null);
        setActivities([]);
        setRisks([]);
        setTeam([]);
        setReports([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  // Construir tarefas para Frappe Gantt
  const parseDeps = (depsStr) => {
    if (!depsStr) return [];
    try {
      const maybeJson = JSON.parse(depsStr);
      if (Array.isArray(maybeJson)) return maybeJson.map(String);
    } catch (e) {
      // not JSON, fall back to comma-separated
    }
    return String(depsStr)
      .split(',')
      .map((d) => d.trim())
      .filter(Boolean);
  };

  const buildGanttTasks = useCallback(() => {
    const toISO = (d) => {
      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const day = String(dt.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
    const statusToProgress = (s) => {
      switch (s) {
        case 'concluido': return 100;
        case 'em_execucao': return 50;
        case 'cancelado': return 0;
        case 'planeado':
        default: return 0;
      }
    };
    const statusText = (s) => {
      switch (s) {
        case 'planeado': return 'Planeado';
        case 'em_execucao': return 'Em Execução';
        case 'concluido': return 'Concluído';
        case 'cancelado': return 'Cancelado';
        default: return 'Desconhecido';
      }
    };

    const inDateRange = (start, end) => {
      if (!ganttDateRange.start && !ganttDateRange.end) return true;
      try {
        const s = new Date(start);
        const e = new Date(end);
        const from = ganttDateRange.start ? new Date(ganttDateRange.start) : null;
        const to = ganttDateRange.end ? new Date(ganttDateRange.end) : null;
        if (from && e < from) return false;
        if (to && s > to) return false;
        return true;
      } catch { return true; }
    };

    const tasks = [];
    (Array.isArray(scheduleTasks) ? scheduleTasks : []).forEach((t) => {
      if (!t.startDate || !t.endDate) return;
      const id = String(t.id ?? t.name);
      if (ganttHiddenIds.has(id)) return;
      const status = t.status || 'planeado';
      if (!(ganttStatusFilter === '__all__' || ganttStatusFilter === status)) return;
      const label = statusText(status);
      if (ganttSearchText && !String(t.name || '').toLowerCase().includes(ganttSearchText.toLowerCase())) return;
      if (ganttResponsibleFilter && !String(t.responsible || '').toLowerCase().includes(ganttResponsibleFilter.toLowerCase())) return;
      if (!inDateRange(t.startDate, t.endDate)) return;
      const outs = Array.isArray(t.outputs) ? t.outputs : [];
      const plannedTotal = outs.reduce((sum, o) => sum + (parseFloat(o.plannedValue) || 0), 0);
      const realTotal = outs.reduce((sum, o) => sum + (parseFloat(o.actualValue) || 0), 0);
      const inPlannedRange = () => {
        const min = ganttPlannedMin !== '' ? parseFloat(ganttPlannedMin) : null;
        const max = ganttPlannedMax !== '' ? parseFloat(ganttPlannedMax) : null;
        if (min != null && plannedTotal < min) return false;
        if (max != null && plannedTotal > max) return false;
        return true;
      };
      const inRealRange = () => {
        const min = ganttRealMin !== '' ? parseFloat(ganttRealMin) : null;
        const max = ganttRealMax !== '' ? parseFloat(ganttRealMax) : null;
        if (min != null && realTotal < min) return false;
        if (max != null && realTotal > max) return false;
        return true;
      };
      if (!inPlannedRange() || !inRealRange()) return;
      tasks.push({
        id,
        name: t.name || '—',
        start: toISO(t.startDate),
        end: toISO(t.endDate),
        progress: statusToProgress(status),
        status,
        statusLabel: label,
        dependencies: parseDeps(t.dependencies).join(','),
        custom_class: `bar-task-${status}`,
        responsible: t.responsible || '',
        plannedTotal,
        realTotal,
        budget: t.budget || ''
      });
      if (ganttShowOutputs) {
        const outs2 = Array.isArray(t.outputs) ? t.outputs : [];
        outs2.forEach((o, idx) => {
          const oId = `${id}-out-${idx}`;
          if (ganttHiddenIds.has(oId)) return;
          const oStart = o.startDate || t.startDate;
          const oEnd = o.endDate || t.endDate;
          const oStatus = o.status || 'pendente';
          const oLabel = oStatus === 'concluido' ? 'Concluído' : 'A concluir';
          if (!inDateRange(oStart, oEnd)) return;
          if (ganttSearchText && !String(o.name || '').toLowerCase().includes(ganttSearchText.toLowerCase())) return;
          if (ganttAssignedToFilter && !String(o.assignedTo || '').toLowerCase().includes(ganttAssignedToFilter.toLowerCase())) return;
          if (!(ganttOutputStateFilter === '__all__' || ganttOutputStateFilter === oStatus)) return;
          const pv = parseFloat(o.plannedValue);
          const av = parseFloat(o.actualValue);
          const inOutPlanned = () => {
            const min = ganttPlannedMin !== '' ? parseFloat(ganttPlannedMin) : null;
            const max = ganttPlannedMax !== '' ? parseFloat(ganttPlannedMax) : null;
            const val = Number.isNaN(pv) ? 0 : pv;
            if (min != null && val < min) return false;
            if (max != null && val > max) return false;
            return true;
          };
          const inOutReal = () => {
            const min = ganttRealMin !== '' ? parseFloat(ganttRealMin) : null;
            const max = ganttRealMax !== '' ? parseFloat(ganttRealMax) : null;
            const val = Number.isNaN(av) ? 0 : av;
            if (min != null && val < min) return false;
            if (max != null && val > max) return false;
            return true;
          };
          if (!inOutPlanned() || !inOutReal()) return;
          tasks.push({
            id: oId,
            name: `• Output: ${o.name || '—'}`,
            start: toISO(oStart),
            end: toISO(oEnd),
            progress: oStatus === 'concluido' ? 100 : 0,
            status: oStatus,
            statusLabel: oLabel,
            dependencies: id,
            custom_class: `bar-output-${oStatus}`,
            assignedTo: o.assignedTo || '',
            plannedValue: o.plannedValue || '',
            actualValue: o.actualValue || '',
            description: o.description || ''
          });
        });
      }
    });
    return tasks;
  }, [scheduleTasks, ganttShowOutputs, ganttStatusFilter, ganttHiddenIds, ganttSearchText, ganttDateRange.start, ganttDateRange.end, ganttResponsibleFilter, ganttAssignedToFilter, ganttPlannedMin, ganttPlannedMax, ganttRealMin, ganttRealMax, ganttOutputStateFilter]);

  // Inicializar/atualizar Frappe Gantt ao abrir o fullscreen
  useEffect(() => {
    if (!ganttFullscreenOpen) return;
    const container = ganttContainerRef.current;
    if (!container) return;
    const tasks = buildGanttTasks();
    container.innerHTML = '';
    if (!tasks || tasks.length === 0) {
      setGanttError('Defina datas e verifique os filtros para visualizar o Gantt.');
      container.innerHTML = '<div style="padding:12px;color:#666">Defina datas e verifique os filtros para visualizar o Gantt.</div>';
      return;
    }
    setGanttError('');
    const gantt = new Gantt(container, tasks, {
      view_mode: ganttViewMode,
      custom_popup_html: (task) => {
        const start = task.start || '';
        const end = task.end || '';
        const statusLine = `<div>Estado: ${task.statusLabel || ''}</div>`;
        const isOutput = String(task.custom_class || '').includes('bar-output');
        const desc = isOutput && task.description ? String(task.description).slice(0, 140) : '';
        const extra = isOutput
          ? `<div>Atribuído: ${task.assignedTo || '—'}</div><div>Previsto: €${Number(task.plannedValue || 0).toFixed(2)}</div><div>Real: €${Number(task.actualValue || 0).toFixed(2)}</div>${desc ? `<div>Descrição: ${desc}${String(task.description).length > 140 ? '…' : ''}</div>` : ''}`
          : `<div>Responsável: ${task.responsible || '—'}</div><div>Previsto total: €${Number(task.plannedTotal || 0).toFixed(2)}</div><div>Real total: €${Number(task.realTotal || 0).toFixed(2)}</div>${task.budget ? `<div>Budget tarefa: €${Number(task.budget || 0).toFixed(2)}</div>` : ''}`;
        return `<div class="details-container"><strong>${task.name}</strong><div>Início: ${start}</div><div>Fim: ${end}</div>${statusLine}${extra}</div>`;
      }
    });
    ganttInstanceRef.current = gantt;
  }, [ganttFullscreenOpen, buildGanttTasks, ganttViewMode]);

  // Validação do formulário de Atividade Global
  const validateNewActivity = (na) => {
    const errs = {};
    if (!na.title) errs.title = 'Título é obrigatório';
    setNewActivityErrors(errs);
    return errs;
  };

  // Sincroniza notas de planeamento com descrições atuais das atividades
  useEffect(() => {
    if (!Array.isArray(activities)) return;
    const map = {};
    activities.forEach((act) => {
      if (act && typeof act.id !== 'undefined') {
        map[act.id] = act.description || '';
      }
    });
    setPlanningNotes(map);

    // Inicializa drafts completos por atividade (título, datas e descrição)
    const drafts = {};
    activities.forEach((act) => {
      if (act && typeof act.id !== 'undefined') {
        drafts[act.id] = {
          title: act.title || '',
          description: act.description || '',
          startDate: toDateInputValue(act.startDate) || '',
          endDate: toDateInputValue(act.endDate) || '',
          isGlobal: Boolean(act.isGlobal) || false,
          tasksText: act.tasksText || '',
          objectivesText: act.objectivesText || ''
        };
      }
    });
    setActivityDrafts(drafts);
  }, [activities]);

  // Inicializa drafts do projeto para edição de Planeamento
  useEffect(() => {
    if (!project) return;
    setProjectDraft({
      scope: project.scope || '',
      objectives: project.objectives || '',
      globalActivitiesDescription: project.globalActivitiesDescription || '',
      globalActivitiesObjectives: project.globalActivitiesObjectives || '',
      globalActivitiesDuration: project.globalActivitiesDuration || '',
      globalActivitiesDeliverables: project.globalActivitiesDeliverables || ''
    });
  }, [project]);

  // Carregar utilizadores para atribuição de papéis na Equipa de Projeto quando editar planeamento
  useEffect(() => {
    const loadUsers = async () => {
      try {
        await ensureLogin();
        const users = await fetchUsers();
        setAllUsers(Array.isArray(users) ? users : []);
      } catch (e) {
        setAllUsers([]);
      }
    };
    if (isPlanningEditing) {
      loadUsers();
    }
  }, [isPlanningEditing]);

  // Carregar utilizadores para resolver o nome/email do Gestor via managerId
  useEffect(() => {
    const loadUsersForManager = async () => {
      try {
        await ensureLogin();
        const users = await fetchUsers();
        setAllUsers(Array.isArray(users) ? users : []);
      } catch (e) {
        // Ignorar falha; mostraremos ID se necessário
      }
    };
    if (project?.managerId && allUsers.length === 0) {
      loadUsersForManager();
    }
  }, [project?.managerId, allUsers.length]);

  // Carregar tarefas do cronograma ao entrar em modo edição de Planeamento
  useEffect(() => {
    const loadScheduleTasks = async () => {
      try {
        await ensureLogin();
        const api = await import('../utils/api');
        const tasks = await api.fetchScheduleTasks(Number(id));
        const normalized = Array.isArray(tasks) ? tasks.map(t => ({
          id: t.id,
          name: t.name || '',
          responsible: t.responsible || '',
          startDate: toDateInputValue(t.startDate) || '',
          endDate: toDateInputValue(t.endDate) || '',
          status: t.status || 'planeado',
          budget: (t.budget !== undefined && t.budget !== null) ? String(t.budget) : '',
          tecnicoOperacoesText: t.tecnicoOperacoesText || '',
          coordenadorTecnicoText: t.coordenadorTecnicoText || '',
          formadorConsultorText: t.formadorConsultorText || '',
          attachments: (() => { try { const arr = JSON.parse(t.attachments || '[]'); return Array.isArray(arr) ? arr : []; } catch(e) { return []; } })(),
          notes: t.notes || '',
          outputs: (() => { try { const arr = JSON.parse(t.outputs || '[]'); return Array.isArray(arr) ? arr : []; } catch(e) { return []; } })()
        })) : [];
        setScheduleTasks(normalized);
        setOriginalScheduleTasks(normalized);
      } catch (e) {
        // Mantém estado local caso falhe
      }
    };
    if (isPlanningEditing) {
      loadScheduleTasks();
    }
  }, [isPlanningEditing, id]);

  // Carregar tarefas do cronograma também fora do modo edição (para visualização e guardar direto)
  useEffect(() => {
    const loadScheduleTasks = async () => {
      try {
        await ensureLogin();
        const api = await import('../utils/api');
        const tasks = await api.fetchScheduleTasks(Number(id));
        setScheduleTasks(Array.isArray(tasks) ? tasks.map(t => ({
          id: t.id,
          name: t.name || '',
          responsible: t.responsible || '',
          startDate: toDateInputValue(t.startDate) || '',
          endDate: toDateInputValue(t.endDate) || '',
          status: t.status || 'planeado',
          budget: (t.budget !== undefined && t.budget !== null) ? String(t.budget) : '',
          tecnicoOperacoesText: t.tecnicoOperacoesText || '',
          coordenadorTecnicoText: t.coordenadorTecnicoText || '',
          formadorConsultorText: t.formadorConsultorText || '',
          attachments: (() => { try { const arr = JSON.parse(t.attachments || '[]'); return Array.isArray(arr) ? arr : []; } catch(e) { return []; } })(),
          notes: t.notes || '',
          outputs: (() => { try { const arr = JSON.parse(t.outputs || '[]'); return Array.isArray(arr) ? arr : []; } catch(e) { return []; } })()
        })) : []);
      } catch (e) {
        // Mantém estado local caso falhe
      }
    };
    if (!isPlanningEditing) {
      loadScheduleTasks();
    }
  }, [isPlanningEditing, id]);

  // Inicializar snapshots de projeto e equipa ao entrar em modo edição
  useEffect(() => {
    if (!isPlanningEditing || !project) return;
    const projSnap = {
      scope: project.scope || '',
      objectives: project.objectives || '',
      globalActivitiesDescription: project.globalActivitiesDescription || '',
      globalActivitiesObjectives: project.globalActivitiesObjectives || '',
      globalActivitiesDuration: project.globalActivitiesDuration || '',
      globalActivitiesDeliverables: project.globalActivitiesDeliverables || ''
    };
    setOriginalProjectDraft(projSnap);
    // Equipa (texto livre): snapshot dos campos informativos do projeto
    const teamSnap = {
      tecnicoOperacoesText: project.tecnicoOperacoesText || '',
      coordenadorTecnicoText: project.coordenadorTecnicoText || '',
      formadorConsultorText: project.formadorConsultorText || ''
    };
    setTeamAssignments(teamSnap);
    setOriginalTeamAssignments(teamSnap);
  }, [isPlanningEditing, project, team]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Sincronizar notas locais quando tarefas carregam/atualizam
  useEffect(() => {
    const map = {};
    (scheduleTasks || []).forEach((t) => { map[t.id] = t.notes || ''; });
    setExecutionNotes(map);
  }, [scheduleTasks]);

  // Alertas de prazo (sininho)
  const notifiedDeadlinesRef = useRef({});
  useEffect(() => {
    if (!project || !Array.isArray(scheduleTasks)) return;
    const now = new Date();
    scheduleTasks.forEach((task) => {
      const s = task.status || 'planeado';
      if (s === 'concluido' || s === 'cancelado') return;
      if (!task.endDate) return;
      const end = new Date(task.endDate);
      const daysLeft = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
      const keySoon = `${task.id}|soon`;
      const keyLate = `${task.id}|late`;
      if (daysLeft < 0 && !notifiedDeadlinesRef.current[keyLate]) {
        try {
          const { pushNotification } = require('../utils/notifications');
          pushNotification({
            title: 'Tarefa atrasada',
            message: `Projeto "${project.title}" — Tarefa "${task.name}" deveria terminar em ${formatDateStr(task.endDate)}.`,
            severity: 'error',
            projectId: project.id,
            taskId: task.id
          });
          notifiedDeadlinesRef.current[keyLate] = true;
        } catch {}
      } else if (daysLeft >= 0 && daysLeft <= 3 && !notifiedDeadlinesRef.current[keySoon]) {
        try {
          const { pushNotification } = require('../utils/notifications');
          pushNotification({
            title: daysLeft === 0 ? 'Prazo termina hoje' : 'Prazo a expirar',
            message: `Projeto "${project.title}" — Tarefa "${task.name}" termina em ${formatDateStr(task.endDate)}${daysLeft === 0 ? '' : ` (em ${daysLeft} dia(s))`}.`,
            severity: daysLeft === 0 ? 'warning' : 'info',
            projectId: project.id,
            taskId: task.id
          });
          notifiedDeadlinesRef.current[keySoon] = true;
        } catch {}
      }
    });
  }, [project, scheduleTasks]);

  // Alertas de outputs (sininho)
  useEffect(() => {
    if (!project || !Array.isArray(scheduleTasks)) return;
    const now = new Date();
    scheduleTasks.forEach((task) => {
      const outs = Array.isArray(task.outputs) ? task.outputs : [];
      outs.forEach((o, idx) => {
        const status = o.status || 'pendente';
        if (status === 'concluido') return;
        const endRef = o.endDate || task.endDate;
        if (!endRef) return;
        const end = new Date(endRef);
        const daysLeft = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
        const keySoon = `${task.id}|out-${idx}|soon`;
        const keyLate = `${task.id}|out-${idx}|late`;
        if (daysLeft < 0 && !notifiedDeadlinesRef.current[keyLate]) {
          try {
            const { pushNotification } = require('../utils/notifications');
            pushNotification({
              title: 'Output atrasado',
              message: `Projeto "${project.title}" — Output "${o.name || '—'}" da tarefa "${task.name}" deveria terminar em ${formatDateStr(endRef)}.`,
              severity: 'error',
              projectId: project.id,
              taskId: task.id
            });
            notifiedDeadlinesRef.current[keyLate] = true;
          } catch {}
        } else if (daysLeft >= 0 && daysLeft <= 3 && !notifiedDeadlinesRef.current[keySoon]) {
          try {
            const { pushNotification } = require('../utils/notifications');
            pushNotification({
              title: daysLeft === 0 ? 'Output termina hoje' : 'Output a expirar',
              message: `Projeto "${project.title}" — Output "${o.name || '—'}" da tarefa "${task.name}" termina em ${formatDateStr(endRef)}${daysLeft === 0 ? '' : ` (em ${daysLeft} dia(s))`}.`,
              severity: daysLeft === 0 ? 'warning' : 'info',
              projectId: project.id,
              taskId: task.id
            });
            notifiedDeadlinesRef.current[keySoon] = true;
          } catch {}
        }
      });
    });
  }, [project, scheduleTasks]);

  // Removido: handler de edição de projeto não é mais usado

  const handleGenerateReport = async () => {
    try {
      await ensureLogin();
      // Cria um relatório associado ao projeto
      const created = await createReport({
        title: `Relatório do Projeto: ${project.title}`,
        type: 'project_summary',
        projectId: Number(id)
      });
      const blob = await downloadReport(created.id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `relatorio-projeto-${project.title || id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      alert('Erro ao gerar relatório.');
    }
  };

  const handleSavePlanning = async () => {
    try {
      // Validações
      const errors = {};
      if (!projectDraft.scope || projectDraft.scope.trim() === '') {
        errors.scope = 'Âmbito é obrigatório.';
      }
      if (!projectDraft.objectives || projectDraft.objectives.trim() === '') {
        errors.objectives = 'Objetivos são obrigatórios.';
      }
      // Validar cronograma (sem progresso)
      const taskErrors = [];
      scheduleTasks.forEach((t, i) => {
        const te = {};
        if (!t.name || t.name.trim() === '') te.name = 'Tarefa é obrigatória.';
        if (!t.startDate) te.startDate = 'Data de início é obrigatória.';
        if (!t.endDate) te.endDate = 'Data de fim é obrigatória.';
        taskErrors[i] = te;
      });
      if (taskErrors.some(te => Object.keys(te).length > 0)) {
        errors.scheduleTasks = taskErrors;
      }
      setValidationErrors(errors);
      if (Object.keys(errors).length > 0) {
        alert('Por favor corrija os erros antes de guardar.');
        return;
      }

      await ensureLogin();
      await updateProject(Number(id), {
        scope: projectDraft.scope,
        objectives: projectDraft.objectives,
        globalActivitiesDescription: projectDraft.globalActivitiesDescription,
        globalActivitiesObjectives: projectDraft.globalActivitiesObjectives,
        globalActivitiesDuration: projectDraft.globalActivitiesDuration,
        globalActivitiesDeliverables: projectDraft.globalActivitiesDeliverables,
        // Removido: campos de equipa por projeto (passam a ser por tarefa)
      });
      // Persistir campos de planeamento por atividade
      const updates = activities.map(async (act) => {
        const d = activityDrafts[act.id] || {};
        const payload = {
          description: d.description ?? act.description ?? '',
          isGlobal: Boolean(d.isGlobal) || false,
          tasksText: d.tasksText || '',
          objectivesText: d.objectivesText || ''
        };
        try {
          await updateActivity(act.id, payload);
        } catch (e) {
          console.warn('Falha ao atualizar atividade', act.id, e);
        }
      });
      await Promise.all(updates);
      // Removido: atribuições de equipa via utilizadores. Usamos texto livre persistido no projeto.

      // Persistir Cronograma de Tarefas (upsert + remoção)
      const api = await import('../utils/api');
      const existing = await api.fetchScheduleTasks(Number(id));
      const existingById = new Map((existing || []).map(t => [t.id, t]));
      const currentIds = new Set(scheduleTasks.filter(t => t.id).map(t => t.id));
      // Atualizar ou criar
      for (const t of scheduleTasks) {
        const payload = {
          name: t.name,
          responsible: t.responsible || null,
          startDate: t.startDate || null,
          endDate: t.endDate || null,
          status: t.status || 'planeado',
          budget: t.budget !== '' ? Number(t.budget) : 0,
          // Equipa por tarefa (texto livre)
          tecnicoOperacoesText: t.tecnicoOperacoesText || '',
          coordenadorTecnicoText: t.coordenadorTecnicoText || '',
          formadorConsultorText: t.formadorConsultorText || ''
        };
        try {
          if (t.id && existingById.has(t.id)) {
            await api.updateScheduleTask(Number(id), t.id, payload);
          } else {
            const created = await api.createScheduleTask(Number(id), payload);
            t.id = created.id; // atualizar estado local
          }
        } catch (e) {
          console.warn('Falha ao persistir tarefa do cronograma', t.name, e);
        }
      }
      // Remover as que foram apagadas localmente
      for (const ex of (existing || [])) {
        if (!currentIds.has(ex.id)) {
          try {
            await api.deleteScheduleTask(Number(id), ex.id);
          } catch (e) {
            console.warn('Falha ao remover tarefa do cronograma', ex.id, e);
          }
        }
      }
      const refreshed = await fetchProjectById(Number(id));
      setProject(refreshed);
      const refreshedActs = await fetchProjectActivities(Number(id));
      setActivities(Array.isArray(refreshedActs) ? refreshedActs : []);
      const apiMod2 = await import('../utils/api');
      const refreshedTeam = await apiMod2.fetchProjectTeam(Number(id));
      setTeam(Array.isArray(refreshedTeam) ? refreshedTeam : []);
      setIsPlanningEditing(false);
      alert('Planeamento guardado com sucesso.');
    } catch (e) {
      alert('Erro ao guardar o planeamento.');
    }
  };

  const handleCancelPlanning = async () => {
    try {
      // Confirmar perda de alterações, se existirem
      const keys = ['scope','objectives','globalActivitiesDescription','globalActivitiesObjectives','globalActivitiesDuration','globalActivitiesDeliverables'];
      const draftDiff = keys.some(k => (projectDraft[k] || '') !== (originalProjectDraft[k] || ''));
      const normTask = (t) => ({ name: t.name || '', responsible: t.responsible || '', startDate: t.startDate || '', endDate: t.endDate || '', status: t.status || 'planeado', budget: t.budget || '', tecnicoOperacoesText: t.tecnicoOperacoesText || '', coordenadorTecnicoText: t.coordenadorTecnicoText || '', formadorConsultorText: t.formadorConsultorText || '' });
      const tasksDiff = JSON.stringify((scheduleTasks || []).map(normTask)) !== JSON.stringify((originalScheduleTasks || []).map(normTask));
      const hasDirty = draftDiff || tasksDiff;
      if (isPlanningEditing && hasDirty) {
        const confirmDiscard = window.confirm('Existem alterações não guardadas. Queres descartar estas alterações?');
        if (!confirmDiscard) return;
      }
      setValidationErrors({});
      await ensureLogin();
      const api = await import('../utils/api');
      // Recarregar projeto e repor drafts
      const refreshed = await api.fetchProjectById(Number(id));
      setProject(refreshed);
      setProjectDraft({
        scope: refreshed.scope || '',
        objectives: refreshed.objectives || '',
        globalActivitiesDescription: refreshed.globalActivitiesDescription || '',
        globalActivitiesObjectives: refreshed.globalActivitiesObjectives || '',
        globalActivitiesDuration: refreshed.globalActivitiesDuration || '',
        globalActivitiesDeliverables: refreshed.globalActivitiesDeliverables || ''
      });
      // Recarregar tarefas do cronograma
      const tasks = await api.fetchScheduleTasks(Number(id));
      const normalized = Array.isArray(tasks) ? tasks.map(t => ({
        id: t.id,
        name: t.name || '',
        responsible: t.responsible || '',
        startDate: toDateInputValue(t.startDate) || '',
        endDate: toDateInputValue(t.endDate) || '',
        status: t.status || 'planeado',
        dependencies: t.dependencies || '',
        budget: (t.budget !== undefined && t.budget !== null) ? String(t.budget) : '',
        tecnicoOperacoesText: t.tecnicoOperacoesText || '',
        coordenadorTecnicoText: t.coordenadorTecnicoText || '',
        formadorConsultorText: t.formadorConsultorText || '',
        notes: t.notes || '',
        attachments: (() => { try { const arr = JSON.parse(t.attachments || '[]'); return Array.isArray(arr) ? arr : []; } catch(e) { return []; } })(),
        outputs: (() => { try { const arr = JSON.parse(t.outputs || '[]'); return Array.isArray(arr) ? arr : []; } catch(e) { return []; } })()
      })) : [];
      setScheduleTasks(normalized);
      // Removido: reposição de equipa por projeto. Campos são agora por tarefa.
    } catch (e) {
      // Ignorar erro; apenas sair do modo edição
    } finally {
      setIsPlanningEditing(false);
    }
  };

  // Utilitário: refrescar tarefas do cronograma do backend
  const refreshScheduleTasks = async () => {
    try {
      await ensureLogin();
      const api = await import('../utils/api');
      const tasks = await api.fetchScheduleTasks(Number(id));
      const normalized = Array.isArray(tasks) ? tasks.map(t => ({
        id: t.id,
        name: t.name || '',
        responsible: t.responsible || '',
        startDate: toDateInputValue(t.startDate) || '',
        endDate: toDateInputValue(t.endDate) || '',
        status: t.status || 'planeado',
        budget: (t.budget !== undefined && t.budget !== null) ? String(t.budget) : '',
        tecnicoOperacoesText: t.tecnicoOperacoesText || '',
        coordenadorTecnicoText: t.coordenadorTecnicoText || '',
        formadorConsultorText: t.formadorConsultorText || '',
        notes: t.notes || '',
        outputs: (() => { try { const arr = JSON.parse(t.outputs || '[]'); return Array.isArray(arr) ? arr : []; } catch(e) { return []; } })()
      })) : [];
      setScheduleTasks(normalized);
    } catch (e) {
      // Ignorar
    }
  };

  // Handlers de tarefas do cronograma
  const handleAddTask = async () => {
    try {
      await ensureLogin();
      const api = await import('../utils/api');
      const payload = {
        name: newTask.name,
        responsible: newTask.responsible || null,
        startDate: newTask.startDate ? new Date(newTask.startDate).toISOString() : null,
        endDate: newTask.endDate ? new Date(newTask.endDate).toISOString() : null,
        status: newTask.status || 'planeado',
        budget: newTask.budget !== '' ? Number(newTask.budget) : 0,
        tecnicoOperacoesText: newTask.tecnicoOperacoesText || '',
        coordenadorTecnicoText: newTask.coordenadorTecnicoText || '',
        formadorConsultorText: newTask.formadorConsultorText || '',
        outputs: JSON.stringify([])
      };
      const created = await api.createScheduleTask(Number(id), payload);
      setScheduleTasks((arr) => [...arr, { ...newTask, id: created.id, budget: payload.budget, outputs: [] }]);
      setNewTask({ name: '', responsible: '', startDate: '', endDate: '', status: 'planeado', budget: '', tecnicoOperacoesText: '', coordenadorTecnicoText: '', formadorConsultorText: '' });
    } catch (e) {
      const msg = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Falha ao criar tarefa.';
      alert(msg);
    }
  };

  const openViewTask = (task) => setViewTask(task);
  const openEditTask = (task) => {
    setEditTask(task);
    setTaskDraft({
      name: task.name || '',
      responsible: task.responsible || '',
      startDate: task.startDate || '',
      endDate: task.endDate || '',
      status: task.status || 'planeado',
      budget: (task.budget !== undefined && task.budget !== null) ? String(task.budget) : '',
      tecnicoOperacoesText: task.tecnicoOperacoesText || '',
      coordenadorTecnicoText: task.coordenadorTecnicoText || '',
      formadorConsultorText: task.formadorConsultorText || '',
      notes: task.notes || ''
    });
    setOutputsDraft(Array.isArray(task.outputs) ? task.outputs.map((o) => ({
      name: o.name || '',
      description: o.description || '',
      assignedTo: o.assignedTo || '',
      startDate: o.startDate || '',
      endDate: o.endDate || '',
      plannedValue: o.plannedValue || '',
      actualValue: o.actualValue || '',
      status: o.status || 'pendente',
      documents: Array.isArray(o.documents) ? o.documents : []
    })) : []);
    const start = task.startDate ? new Date(task.startDate) : null;
    const end = task.endDate ? new Date(task.endDate) : null;
    setTaskEditErrors({ dateOrder: (start && end && start > end) ? 'Data de início deve ser anterior ou igual à data de fim.' : '' });
    setOutputsErrors((Array.isArray(task.outputs) ? task.outputs : []).map((o) => {
      const errs = {};
      if (!o.name || String(o.name).trim() === '') errs.name = 'Nome obrigatório.';
      const pv = parseFloat(o.plannedValue);
      if (Number.isNaN(pv) || pv < 0) errs.plannedValue = 'Valor previsto deve ser ≥ 0.';
      const hasAV = o.actualValue !== undefined && o.actualValue !== '';
      const av = parseFloat(o.actualValue);
      if (hasAV && (Number.isNaN(av) || av < 0)) errs.actualValue = 'Valor real deve ser ≥ 0.';
      if ((o.status || 'pendente') === 'concluido' && !hasAV) errs.actualValue = 'Valor real obrigatório em Concluído.';
      return errs;
    }));
  };

  const validateOutputRow = (o, taskEndDate) => {
    const errs = {};
    if (!o.name || String(o.name).trim() === '') errs.name = 'Nome obrigatório.';
    const pv = parseFloat(o.plannedValue);
    if (Number.isNaN(pv) || pv < 0) errs.plannedValue = 'Valor previsto deve ser ≥ 0.';
    const hasAV = o.actualValue !== undefined && o.actualValue !== '';
    const av = parseFloat(o.actualValue);
    if (hasAV && (Number.isNaN(av) || av < 0)) errs.actualValue = 'Valor real deve ser ≥ 0.';
    if ((o.status || 'pendente') === 'concluido' && !hasAV) errs.actualValue = 'Valor real obrigatório em Concluído.';
    if (o.startDate && o.endDate) {
      try {
        const s = new Date(o.startDate);
        const e = new Date(o.endDate);
        if (s > e) errs.dateOrder = 'Início deve ser anterior ou igual ao fim.';
      } catch {}
    }
    if (taskEndDate && o.endDate) {
      try {
        const e = new Date(o.endDate);
        const tEnd = new Date(taskEndDate);
        if (e > tEnd) errs.taskDateBound = 'Output não pode terminar após a tarefa.';
      } catch {}
    }
    return errs;
  };

  // Gerar PDF do relatório de execução (captura da secção)
  const generateExecutionReport = async () => {
    try {
      const node = document.getElementById('execucao-report-root');
      if (!node) {
        alert('Secção de Execução não encontrada para exportação.');
        return;
      }
      const canvas = await html2canvas(node, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      // Título
      const title = `Relatório de Execução — ${project?.title ?? ''}`;
      pdf.setFontSize(14);
      pdf.text(title, margin, 15);
      // Imagem ajustada
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let y = 22;
      if (imgHeight <= pageHeight - y - margin) {
        pdf.addImage(imgData, 'PNG', margin, y, imgWidth, imgHeight);
      } else {
        // Dividir imagem em múltiplas páginas se for longa
        let remainingHeight = imgHeight;
        let sY = 0;
        const scale = imgWidth / canvas.width;
        const pageContentHeight = pageHeight - y - margin;
        while (remainingHeight > 0) {
          const sliceHeightPx = pageContentHeight / scale;
          const sliceCanvas = document.createElement('canvas');
          sliceCanvas.width = canvas.width;
          sliceCanvas.height = Math.min(sliceHeightPx, canvas.height - sY);
          const ctx = sliceCanvas.getContext('2d');
          ctx.drawImage(canvas, 0, sY, canvas.width, sliceCanvas.height, 0, 0, canvas.width, sliceCanvas.height);
          const sliceImg = sliceCanvas.toDataURL('image/png');
          pdf.addImage(sliceImg, 'PNG', margin, y, imgWidth, (sliceCanvas.height * imgWidth) / canvas.width);
          remainingHeight -= (sliceCanvas.height * imgWidth) / canvas.width;
          sY += sliceCanvas.height;
          if (remainingHeight > 0) {
            pdf.addPage();
            y = margin;
          }
        }
      }
      const dateStr = new Date().toISOString().slice(0, 10);
      pdf.save(`relatorio_execucao_${project?.id ?? 'projeto'}_${dateStr}.pdf`);
    } catch (err) {
      console.error('Falha ao gerar relatório de execução', err);
      alert('Falha ao gerar relatório de execução.');
    }
  };

  // Removidos: helpers de Templates (agora existem na página lateral dedicada)

  const handleUploadTaskAttachment = async (task, evt) => {
    const files = Array.from(evt.target.files || []);
    if (!files.length) return;
    try {
      const relPath = `tasks/${task.id}`;
      const uploaded = await uploadStorage(Number(id), relPath, files);
      const list = Array.isArray(uploaded) ? uploaded : (uploaded?.files || []);
      const newUrls = list.map(u => u.url || u.path).filter(Boolean);
      const nextAttachments = [...(Array.isArray(task.attachments) ? task.attachments : []), ...newUrls];
      const payload = {
        name: task.name || '',
        responsible: task.responsible || '',
        startDate: task.startDate || '',
        endDate: task.endDate || '',
        status: task.status || 'planeado',
        budget: task.budget !== '' ? Number(task.budget) : (Number(task.budget) || 0),
        tecnicoOperacoesText: task.tecnicoOperacoesText || '',
        coordenadorTecnicoText: task.coordenadorTecnicoText || '',
        formadorConsultorText: task.formadorConsultorText || '',
        notes: task.notes || '',
        attachments: JSON.stringify(nextAttachments),
        outputs: JSON.stringify(Array.isArray(task.outputs) ? task.outputs : [])
      };
      await updateScheduleTask(Number(id), task.id, payload);
      await refreshScheduleTasks();
      evt.target.value = '';
    } catch (e) {
      alert('Falha ao anexar ficheiros à tarefa.');
    }
  };

  const handleRemoveTaskAttachment = async (task, url) => {
    const ok = window.confirm('Remover este documento da tarefa?');
    if (!ok) return;
    try {
      const rel = url.replace(`${getApiHost()}`, '');
      await deleteStorage(Number(id), rel);
      const next = (Array.isArray(task.attachments) ? task.attachments : []).filter(u => u !== url);
      const payload = {
        name: task.name || '',
        responsible: task.responsible || '',
        startDate: task.startDate || '',
        endDate: task.endDate || '',
        status: task.status || 'planeado',
        budget: task.budget !== '' ? Number(task.budget) : (Number(task.budget) || 0),
        tecnicoOperacoesText: task.tecnicoOperacoesText || '',
        coordenadorTecnicoText: task.coordenadorTecnicoText || '',
        formadorConsultorText: task.formadorConsultorText || '',
        notes: task.notes || '',
        attachments: JSON.stringify(next),
        outputs: JSON.stringify(Array.isArray(task.outputs) ? task.outputs : [])
      };
      await updateScheduleTask(Number(id), task.id, payload);
      await refreshScheduleTasks();
      setSnackbar({ open: true, message: 'Documento removido da tarefa', severity: 'success' });
    } catch (e) {
      setSnackbar({ open: true, message: 'Falha ao remover documento da tarefa', severity: 'error' });
    }
  };

  const handleRemoveOutputDocument = async (task, outIndex, docUrl) => {
    const ok = window.confirm('Remover este documento do output?');
    if (!ok) return;
    try {
      const rel = docUrl.replace(`${getApiHost()}`, '');
      await deleteStorage(Number(id), rel);
    } catch {}
    try {
      const outs = Array.isArray(task.outputs) ? task.outputs.map((o, i) => (
        i === outIndex ? { ...o, documents: (Array.isArray(o.documents) ? o.documents.filter((d) => d !== docUrl) : []) } : o
      )) : [];
      const payload = {
        name: task.name || '',
        responsible: task.responsible || '',
        startDate: task.startDate || '',
        endDate: task.endDate || '',
        status: task.status || 'planeado',
        budget: task.budget !== '' ? Number(task.budget) : (Number(task.budget) || 0),
        tecnicoOperacoesText: task.tecnicoOperacoesText || '',
        coordenadorTecnicoText: task.coordenadorTecnicoText || '',
        formadorConsultorText: task.formadorConsultorText || '',
        notes: task.notes || '',
        attachments: JSON.stringify(Array.isArray(task.attachments) ? task.attachments : []),
        outputs: JSON.stringify(outs)
      };
      await updateScheduleTask(Number(id), task.id, payload);
      await refreshScheduleTasks();
      setSnackbar({ open: true, message: 'Documento removido do output', severity: 'success' });
    } catch (e) {
      setSnackbar({ open: true, message: 'Falha ao remover documento do output', severity: 'error' });
    }
  };

  const handleQuickUploadOutputDocument = async (task, outIndex, evt) => {
    const files = Array.from(evt.target.files || []);
    if (!files.length || !task?.id) return;
    try {
      await ensureLogin();
      const relPath = `tasks/${task.id}/outputs/${outIndex}`;
      const uploaded = await uploadStorage(Number(id), relPath, files);
      const list = Array.isArray(uploaded) ? uploaded : (uploaded?.files || []);
      const urls = list.map(u => ({ url: (u.url || u.path), uploadedAt: new Date().toISOString() })).filter(d => !!d.url);
      const outs = Array.isArray(task.outputs) ? task.outputs.map((o, i) => (
        i === outIndex ? { ...o, documents: [...(Array.isArray(o.documents) ? o.documents : []), ...urls] } : o
      )) : [];
      const payload = {
        name: task.name || '',
        responsible: task.responsible || '',
        startDate: task.startDate || '',
        endDate: task.endDate || '',
        status: task.status || 'planeado',
        budget: task.budget !== '' ? Number(task.budget) : (Number(task.budget) || 0),
        tecnicoOperacoesText: task.tecnicoOperacoesText || '',
        coordenadorTecnicoText: task.coordenadorTecnicoText || '',
        formadorConsultorText: task.formadorConsultorText || '',
        notes: task.notes || '',
        attachments: JSON.stringify(Array.isArray(task.attachments) ? task.attachments : []),
        outputs: JSON.stringify(outs)
      };
      await updateScheduleTask(Number(id), task.id, payload);
      await refreshScheduleTasks();
      setSnackbar({ open: true, message: 'Documento adicionado ao output', severity: 'success' });
      evt.target.value = '';
    } catch (e) {
      setSnackbar({ open: true, message: 'Falha ao adicionar documento ao output', severity: 'error' });
    }
  };

  // Guardar nota de execução para uma tarefa
  const handleSaveTaskNote = async (task) => {
    try {
      await ensureLogin();
      const api = await import('../utils/api');
      const noteText = executionNotes[task.id] ?? '';
      const payload = {
        name: task.name,
        responsible: task.responsible || null,
        startDate: task.startDate || null,
        endDate: task.endDate || null,
        status: task.status || 'planeado',
        budget: task.budget !== '' ? Number(task.budget) : (Number(task.budget) || 0),
        tecnicoOperacoesText: task.tecnicoOperacoesText || '',
        coordenadorTecnicoText: task.coordenadorTecnicoText || '',
        formadorConsultorText: task.formadorConsultorText || '',
        notes: noteText,
        outputs: JSON.stringify(Array.isArray(task.outputs) ? task.outputs : [])
      };
      await api.updateScheduleTask(Number(id), task.id, payload);
      await refreshScheduleTasks();
    } catch (e) {
      alert('Falha ao guardar notas da tarefa.');
    }
  };

  const handleSaveEditTask = async () => {
    if (!editTask) return;
    try {
      if (taskEditErrors.dateOrder) return;
      const hasOutputErrors = (Array.isArray(outputsErrors) ? outputsErrors : []).some((e) => Object.keys(e || {}).length > 0);
      if (hasOutputErrors) return;
      // Regras adicionais: outputs não podem ultrapassar data da tarefa e orçamento do projeto
      const invalidDateRows = (Array.isArray(outputsDraft) ? outputsDraft : []).some((o) => {
        if (!o.endDate || !taskDraft.endDate) return false;
        try { return new Date(o.endDate) > new Date(taskDraft.endDate); } catch { return false; }
      });
      if (invalidDateRows) return;
      const totalPrevisto = (Array.isArray(outputsDraft) ? outputsDraft : []).reduce((sum, o) => sum + (parseFloat(o.plannedValue) || 0), 0);
      if (taskDraft?.budget && Number(taskDraft.budget) > 0 && totalPrevisto > Number(taskDraft.budget)) {
        alert('Total previsto dos outputs desta tarefa excede o orçamento da tarefa.');
        return;
      }
      if (project?.budget && Number(project.budget) > 0) {
        const nextTasksBudgetSum = (scheduleTasks || []).reduce((acc, t) => acc + (Number(t.budget) || 0), 0)
          - (Number(editTask?.budget) || 0) + (Number(taskDraft.budget) || 0);
        if (nextTasksBudgetSum > Number(project.budget)) {
          alert('Soma dos budgets das tarefas excede o orçamento do projeto.');
          return;
        }
      }
      await ensureLogin();
      const api = await import('../utils/api');
      const payload = {
        name: taskDraft.name,
        responsible: taskDraft.responsible || null,
        startDate: taskDraft.startDate || null,
        endDate: taskDraft.endDate || null,
        status: taskDraft.status || 'planeado',
        budget: taskDraft.budget !== '' ? Number(taskDraft.budget) : 0,
        tecnicoOperacoesText: taskDraft.tecnicoOperacoesText || '',
        coordenadorTecnicoText: taskDraft.coordenadorTecnicoText || '',
        formadorConsultorText: taskDraft.formadorConsultorText || '',
        notes: taskDraft.notes || '',
        outputs: JSON.stringify(Array.isArray(outputsDraft) ? outputsDraft : [])
      };
      await api.updateScheduleTask(Number(id), editTask.id, payload);
      await refreshScheduleTasks();
      setEditTask(null);
    } catch (e) {
      alert('Falha ao guardar alterações da tarefa.');
    }
  };

  const handleDeleteTask = async (task) => {
    if (!task?.id) return;
    const confirmDelete = window.confirm(`Apagar a tarefa "${task.name}"?`);
    if (!confirmDelete) return;
    try {
      setDeletingTaskId(task.id);
      await ensureLogin();
      const api = await import('../utils/api');
      await api.deleteScheduleTask(Number(id), task.id);
      await refreshScheduleTasks();
    } catch (e) {
      alert('Falha ao apagar a tarefa.');
    } finally {
      setDeletingTaskId(null);
    }
  };

  // Outputs helpers
  const getTaskOutputTotals = (task) => {
    const outs = Array.isArray(task.outputs) ? task.outputs : [];
    const totalPrevisto = outs.reduce((sum, o) => sum + (parseFloat(o.plannedValue) || 0), 0);
    const totalReal = outs.reduce((sum, o) => sum + (parseFloat(o.actualValue) || 0), 0);
    const concluidos = outs.filter((o) => (o.status || 'pendente') === 'concluido').length;
    return { count: outs.length, previsto: totalPrevisto, real: totalReal, concluidos };
  };

  const getOutputsSummaryAcrossTasks = () => {
    const totals = { count: 0, concluidos: 0, pendentes: 0, previsto: 0, real: 0 };
    (Array.isArray(scheduleTasks) ? scheduleTasks : []).forEach((t) => {
      const outs = Array.isArray(t.outputs) ? t.outputs : [];
      totals.count += outs.length;
      totals.concluidos += outs.filter((o) => (o.status || 'pendente') === 'concluido').length;
      totals.pendentes += outs.filter((o) => (o.status || 'pendente') !== 'concluido').length;
      totals.previsto += outs.reduce((sum, o) => sum + (parseFloat(o.plannedValue) || 0), 0);
      totals.real += outs.reduce((sum, o) => sum + (parseFloat(o.actualValue) || 0), 0);
    });
    return totals;
  };

  const addOutputToTask = (taskId) => {
    setScheduleTasks((prev) => prev.map((t) => {
      if (t.id !== taskId) return t;
      const next = Array.isArray(t.outputs) ? [...t.outputs] : [];
      next.push({ name: '', description: '', assignedTo: '', startDate: '', endDate: '', plannedValue: '', actualValue: '', status: 'pendente' });
      return { ...t, outputs: next };
    }));
  };

  const updateOutputField = (taskId, idx, field, value) => {
    setScheduleTasks((prev) => prev.map((t) => {
      if (t.id !== taskId) return t;
      const next = (Array.isArray(t.outputs) ? t.outputs.map((o, i) => (i === idx ? { ...o, [field]: value } : o)) : []);
      return { ...t, outputs: next };
    }));
  };

  const removeOutputFromTask = (taskId, idx) => {
    setScheduleTasks((prev) => prev.map((t) => {
      if (t.id !== taskId) return t;
      const next = (Array.isArray(t.outputs) ? t.outputs.filter((_, i) => i !== idx) : []);
      return { ...t, outputs: next };
    }));
  };

  const handleSaveTaskOutputs = async (task) => {
    try {
      await ensureLogin();
      const api = await import('../utils/api');
      const outs = Array.isArray(task.outputs) ? task.outputs : [];
      // Validação simples: nome obrigatório, valores numéricos e não negativos
      for (let i = 0; i < outs.length; i++) {
        const o = outs[i] || {};
        if (!o.name || String(o.name).trim() === '') {
          alert(`Output #${i + 1}: Nome é obrigatório.`);
          return;
        }
        const pv = parseFloat(o.plannedValue);
        const av = parseFloat(o.actualValue);
        if (Number.isNaN(pv) || pv < 0) {
          alert(`Output #${i + 1}: Valor previsto deve ser um número ≥ 0.`);
          return;
        }
        if (o.actualValue !== undefined && o.actualValue !== '' && (Number.isNaN(av) || av < 0)) {
          alert(`Output #${i + 1}: Valor real deve ser um número ≥ 0.`);
          return;
        }
      }
      // Validação: total previsto dos outputs não excede budget da tarefa
      const totalPrevisto = outs.reduce((sum, o) => sum + (parseFloat(o.plannedValue) || 0), 0);
      if (task?.budget && Number(task.budget) > 0 && totalPrevisto > Number(task.budget)) {
        alert('Total previsto dos outputs excede o orçamento da tarefa.');
        return;
      }
      const payload = {
        name: task.name,
        responsible: task.responsible || null,
        startDate: task.startDate || null,
        endDate: task.endDate || null,
        status: task.status || 'planeado',
        budget: task.budget !== '' ? Number(task.budget) : (Number(task.budget) || 0),
        tecnicoOperacoesText: task.tecnicoOperacoesText || '',
        coordenadorTecnicoText: task.coordenadorTecnicoText || '',
        formadorConsultorText: task.formadorConsultorText || '',
        notes: task.notes || '',
        attachments: JSON.stringify(Array.isArray(task.attachments) ? task.attachments : []),
        outputs: JSON.stringify(outs)
      };
      await api.updateScheduleTask(Number(id), task.id, payload);
      await refreshScheduleTasks();
    } catch (e) {
      alert('Falha ao guardar outputs da tarefa.');
    }
  };

  const handleAddTeamMember = async () => {
    try {
      await ensureLogin();
      const email = window.prompt('Email do novo membro:');
      if (!email) return;
      const role = window.prompt('Função (admin/manager):', 'manager');
      const added = await addProjectMember(id, { email, role });
      // Atualiza a equipa
      const t = await fetchProjectTeam(id);
      setTeam(t);
    } catch (e) {
      alert('Não foi possível adicionar membro à equipa.');
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'planning': return '#FFCE56';
      case 'kickoff': return '#36A2EB';
      case 'execution': return '#FF6384';
      case 'closing': return '#4BC0C0';
      case 'completed': return '#9966FF';
      case 'in_progress': return '#4CAF50';
      case 'pending': return '#9E9E9E';
      case 'delayed': return '#F44336';
      default: return '#999999';
    }
  };

  // Helpers para visualização tipo Gantt
  const toDate = (s) => (s ? new Date(s) : null);
  const diffDays = (a, b) => Math.max(0, Math.ceil((b - a) / (1000 * 60 * 60 * 24)));
  const getTimelineBounds = () => {
    const starts = scheduleTasks.map(t => toDate(t.startDate)).filter(Boolean);
    const ends = scheduleTasks.map(t => toDate(t.endDate)).filter(Boolean);
    if (starts.length === 0 || ends.length === 0) return null;
    const min = new Date(Math.min(...starts.map(d => d.getTime())));
    const max = new Date(Math.max(...ends.map(d => d.getTime())));
    if (min > max) return null;
    return { min, max, days: diffDays(min, max) || 1 };
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'planning': return 'Planeamento';
      case 'kickoff': return 'Kick-off';
      case 'execution': return 'Execução';
      case 'closing': return 'Encerramento';
      case 'completed': return 'Concluído';
      case 'in_progress': return 'Em Progresso';
      case 'pending': return 'Pendente';
      case 'delayed': return 'Atrasado';
      default: return 'Desconhecido';
    }
  };

  const formatDateStr = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return formatDateUtil(date);
  };

  const toDateInputValue = (dateString) => {
    if (!dateString) return '';
    try {
      const d = new Date(dateString);
      const iso = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString();
      return iso.slice(0, 10);
    } catch {
      return '';
    }
  };

  // Nome do Gestor de Projeto (escolhido na criação do projeto)
  // Nota: o papel pode vir de u.team.role OU u.Team.role (Sequelize)
  const managerUser = (Array.isArray(team) ? team : []).find(u => ((u.team?.role || u.Team?.role || u.role) === 'gerente'));
  const managerFromUsers = (Array.isArray(allUsers) && project?.managerId) ? allUsers.find(u => u.id === project.managerId) : null;
  const projectManagerDisplay = managerUser
    ? (managerUser.name || managerUser.email || String(managerUser.id))
    : (managerFromUsers
        ? (managerFromUsers.name || managerFromUsers.email || String(managerFromUsers.id))
        : (project?.managerId ? String(project.managerId) : '—'));

  // Removido: handler de Kick-off
  const openViewActivity = (activity) => {
    setViewActivity(activity);
  };

  const openEditActivity = (activity) => {
    setEditActivity(activity);
    setEditDraft({
      title: activity.title || '',
      description: activity.description || '',
      objectivesText: activity.objectivesText || '',
      tasksText: activity.tasksText || '',
      deliverablesText: activity.deliverablesText || ''
    });
  };

  const handleDeleteActivity = async (activity) => {
    if (!activity?.id) return;
    const ok = window.confirm('Apagar esta atividade global? Esta ação é irreversível.');
    if (!ok) return;
    try {
      setDeletingActivityId(activity.id);
      await ensureLogin();
      await deleteActivity(activity.id);
      const refreshed = await fetchProjectActivities(Number(id));
      setActivities(Array.isArray(refreshed) ? refreshed : []);
    } catch (err) {
      alert('Falha ao apagar atividade');
    } finally {
      setDeletingActivityId(null);
    }
  };

  const handleSaveEditActivity = async () => {
    if (!editActivity?.id) return;
    try {
      await ensureLogin();
      await updateActivity(editActivity.id, {
        title: editDraft.title,
        description: editDraft.description,
        objectivesText: editDraft.objectivesText,
        deliverablesText: editDraft.deliverablesText,
        isGlobal: true,
        projectId: Number(id)
      });
      const refreshed = await fetchProjectActivities(Number(id));
      setActivities(Array.isArray(refreshed) ? refreshed : []);
      setEditActivity(null);
    } catch (err) {
      alert('Falha ao guardar alterações da atividade');
    }
  };

  if (loading || !project) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Typography>A carregar detalhes do projeto…</Typography>
      </Box>
    );
  }

  return (
    <Box id="project-report-root">
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={() => navigate('/projects')} sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
          <Typography variant="h4" component="div">
            {project.title}
          </Typography>
          <Chip label={`ID ${project.id}`} size="small" variant="outlined" color="default" />
        </Box>
        {/* Botão Editar removido conforme requisito */}
        <Button 
          variant="contained" 
          startIcon={<AssessmentIcon />}
          onClick={() => {
            try {
              const titleSafe = String(project?.title || 'Projeto').replace(/[^a-z0-9\-_]+/gi, '_');
              const header = `<!DOCTYPE html><html><head><meta charset=\"UTF-8\"><title>Manual do Projeto</title></head><body>`;
              const footer = `</body></html>`;
              const fmt = (v) => (v === null || typeof v === 'undefined' || v === '' ? '—' : String(v));
              const fmtText = (v) => {
                const s = fmt(v);
                return s === '—' ? s : String(s).replace(/\r?\n/g, '<br/>');
              };
              const pick = (key) => {
                const pd = (projectDraft && Object.prototype.hasOwnProperty.call(projectDraft, key)) ? projectDraft[key] : undefined;
                const pv = pd !== undefined && pd !== null && pd !== '' ? pd : (project ? project[key] : undefined);
                return pv;
              };
              const computeGlobalFromActivities = () => {
                const globals = (activities || []).filter(a => Boolean(a.isGlobal));
                const joinText = (arr, mapper) => {
                  const parts = arr.map(mapper).filter(x => x && String(x).trim().length);
                  return parts.length ? parts.join('<br/>') : '—';
                };
                const desc = joinText(globals, g => g.description);
                const obj = joinText(globals, g => g.objectivesText);
                const tasks = joinText(globals, g => g.tasksText);
                return { desc, obj, tasks };
              };
              const globalFallback = computeGlobalFromActivities();
              const tasks = Array.isArray(scheduleTasks) ? scheduleTasks : [];
              let html = header;
              html += `<h1>Manual do Projeto</h1>`;
              html += `<h2>Identificação</h2>`;
              html += `<p><strong>Título:</strong> ${fmt(project?.title)}</p>`;
              html += `<p><strong>Código:</strong> ${fmt(project?.code)}</p>`;
              html += `<p><strong>Status:</strong> ${fmt(project?.status)}</p>`;
              html += `<p><strong>Cliente:</strong> ${fmt(project?.client)}</p>`;
              html += `<p><strong>Datas:</strong> ${fmt(project?.startDate)} — ${fmt(project?.endDate)}</p>`;
              html += `<p><strong>Orçamento:</strong> ${fmt(project?.budget)}</p>`;
              html += `<h2>Âmbito e Objetivos</h2>`;
              html += `<p><strong>Descrição:</strong> ${fmtText(pick('description'))}</p>`;
              html += `<p><strong>Objetivos:</strong> ${fmtText(pick('objectives'))}</p>`;
              html += `<p><strong>Âmbito:</strong> ${fmtText(pick('scope'))}</p>`;
              html += `<h2>Atividades Globais</h2>`;
              html += `<p><strong>Descrição:</strong> ${fmtText(pick('globalActivitiesDescription') || globalFallback.desc)}</p>`;
              html += `<p><strong>Objetivos:</strong> ${fmtText(pick('globalActivitiesObjectives') || globalFallback.obj)}</p>`;
              const durVal = pick('globalActivitiesDuration');
              if (durVal && String(durVal).trim().length) {
                html += `<p><strong>Duração:</strong> ${fmtText(durVal)}</p>`;
              }
              html += `<p><strong>Entregáveis:</strong> ${fmtText(pick('globalActivitiesDeliverables') || globalFallback.tasks)}</p>`;
              html += `<h2>Equipa</h2>`;
              html += `<p><strong>Técnico de Operações:</strong> ${fmtText(pick('tecnicoOperacoesText'))}</p>`;
              html += `<p><strong>Coordenador Técnico:</strong> ${fmtText(pick('coordenadorTecnicoText'))}</p>`;
              html += `<p><strong>Formador/Consultor:</strong> ${fmtText(pick('formadorConsultorText'))}</p>`;
              html += `<h2>Cronograma de Tarefas</h2>`;
              tasks.forEach((t) => {
                html += `<h3>${fmt(t.name)} (${fmt(t.startDate)} — ${fmt(t.endDate)})</h3>`;
                html += `<p><strong>Responsável:</strong> ${fmt(t.responsible)} | <strong>Estado:</strong> ${fmt(t.status)}</p>`;
                html += `<p><strong>Notas:</strong> ${fmt(t.notes)}</p>`;
                if (Array.isArray(t.attachments) && t.attachments.length) {
                  html += `<p><strong>Documentos:</strong></p><ul>`;
                  (t.attachments || []).forEach((u) => { html += `<li>${fmt(u)}</li>`; });
                  html += `</ul>`;
                }
                const outs = (() => { try { const arr = JSON.parse(t.outputs || '[]'); return Array.isArray(arr) ? arr : []; } catch(e){ return []; } })();
                if (outs.length) {
                  html += `<h4>Outputs</h4>`;
                  outs.forEach((o) => {
                    html += `<p><strong>${fmt(o.name)}</strong> — ${fmt(o.description)}<br/>`+
                            `<em>${fmt(o.startDate)} — ${fmt(o.endDate)}</em><br/>`+
                            `Previsto: ${fmt(o.plannedValue)} · Real: ${fmt(o.actualValue)}</p>`;
                    if (Array.isArray(o.documents) && o.documents.length) {
                      html += `<ul>`;
                      (o.documents || []).forEach((d) => { const urlStr = typeof d === 'string' ? d : (d?.url || ''); html += `<li>${fmt(urlStr)}</li>`; });
                      html += `</ul>`;
                    }
                  });
                }
              });
              html += footer;
              const blob = new Blob([html], { type: 'application/msword' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `${titleSafe}_Manual_do_Projeto.doc`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            } catch(e) {
              alert('Não foi possível gerar o Manual do Projeto.');
            }
          }}
        >
          Manual do Projeto (Word)
        </Button>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Paper sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Typography variant="h6" gutterBottom>
                Informações do Projeto
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Código
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {project.code}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Status
                  </Typography>
                  <Chip 
                    label={getStatusText(project.status)} 
                    size="small" 
                    sx={{ backgroundColor: getStatusColor(project.status), color: 'white' }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Data de Início
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {formatDateStr(project.startDate)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Data de Término
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {formatDateStr(project.endDate)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Cliente
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {project.client}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Contacto do Cliente
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {project.clientContactName || '—'}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.clientContactEmail || '—'}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.clientContactPhone || '—'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Orçamento
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {formatCurrency(project.budget)}
                  </Typography>
                </Grid>
                {/* Campo "Nível de Risco" removido conforme requisito */}
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Comercial ISQ
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {project.isqCommercialName || '—'}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.isqCommercialEmail || '—'}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.isqCommercialPhone || '—'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Gestor de Projeto
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {projectManagerDisplay}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Proposta
                  </Typography>
                  {project.proposalPath ? (
                    <Button
                      variant="text"
                      color="primary"
                      startIcon={<DownloadIcon />}
                      onClick={() => {
                        try {
                          const host = getApiHost();
                          const url = `${host}${project.proposalPath}`;
                          const a = document.createElement('a');
                          a.href = url;
                          a.target = '_blank';
                          const baseName = (project?.title || 'proposta').replace(/[^a-z0-9\-\_]+/gi, '_');
                          a.download = `${baseName}-proposta_comercial.pdf`;
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                        } catch (err) {
                          alert('Não foi possível baixar a proposta.');
                        }
                      }}
                    >
                      Baixar Proposta Comercial
                    </Button>
                  ) : (
                    <Typography variant="body1" gutterBottom>—</Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="h6" gutterBottom>
                  Progresso do Projeto
                </Typography>
                {/* botão manual removido aqui; existe no topo da página */}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                  <LinearProgress 
                    variant="determinate" 
                    value={project.completionPercentage} 
                    sx={{ height: 10, borderRadius: 5 }}
                  />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                  <Typography variant="body2" color="textSecondary">
                    {project.completionPercentage}%
                  </Typography>
                </Box>
              </Box>
              {/* Secção de documentos removida para simplificação */}
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="project tabs">
            <Tab label="Planeamento" />
            <Tab label="Execução" />
          </Tabs>
          <Box sx={{ ml: 'auto', pr: 2, display: 'flex', gap: 1 }}>
            {/* Removido: botão Templates aqui para evitar duplicação com a Sidebar */}
            {tabValue === 0 && (
              <>
                {!isPlanningEditing && (
                  <Button variant="outlined" onClick={() => setIsPlanningEditing(true)}>Editar</Button>
                )}
                {isPlanningEditing && (
                  <Button variant="outlined" color="inherit" onClick={handleCancelPlanning}>Cancelar</Button>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSavePlanning}
                  disabled={!isPlanningEditing || (() => {
                    const keys = ['scope','objectives','globalActivitiesDescription','globalActivitiesObjectives','globalActivitiesDuration','globalActivitiesDeliverables'];
                    const draftDiff = keys.some(k => (projectDraft[k] || '') !== (originalProjectDraft[k] || ''));
                    const normTask = (t) => ({ name: t.name || '', responsible: t.responsible || '', startDate: t.startDate || '', endDate: t.endDate || '', status: t.status || 'planeado', budget: t.budget || '', tecnicoOperacoesText: t.tecnicoOperacoesText || '', coordenadorTecnicoText: t.coordenadorTecnicoText || '', formadorConsultorText: t.formadorConsultorText || '' });
                    const tasksDiff = JSON.stringify((scheduleTasks || []).map(normTask)) !== JSON.stringify((originalScheduleTasks || []).map(normTask));
                    return !(draftDiff || tasksDiff);
                  })()}
                >
                  Guardar
                </Button>
              </>
            )}
          </Box>
        </Box>
        
        {/* Tab de Execução */}
        {tabValue === 1 && (
          <Box sx={{ p: 3 }} id="execucao-report-root">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="h6" gutterBottom>
                    Execução
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Registe notas por tarefa e acompanhe o estado em execução.
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Paper sx={{ p: 0 }}>
                  <List>
                    {scheduleTasks.length === 0 && (
                      <ListItem>
                        <ListItemText primary="Nenhuma tarefa." />
                      </ListItem>
                    )}
                    {scheduleTasks.map((task) => (
                      <ListItem key={task.id || task.name} alignItems="flex-start" divider>
                        <Grid container spacing={2} sx={{ width: '100%' }}>
                          <Grid item xs={12} md={8}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <Box>
                                <Typography variant="subtitle1">{`${task.name} • ${formatDateStr(task.startDate)} — ${formatDateStr(task.endDate)}`}</Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                  {`Responsável: ${task.responsible || '—'} | Estado: ${(() => {
                                    const s = task.status || 'planeado';
                                    switch (s) {
                                      case 'planeado': return 'Planeado';
                                      case 'em_execucao': return 'Em Execução';
                                      case 'concluido': return 'Concluído';
                                      case 'cancelado': return 'Cancelado';
                                      default: return 'Desconhecido';
                                    }
                                  })()}`}
                                </Typography>
                                {(() => {
                                  const totals = getTaskOutputTotals(task);
                                  const projectBudget = Number(project?.budget || 0);
                                  const taskBudget = Number(task?.budget || 0);
                                  const pctTask = taskBudget > 0 ? (totals.previsto / taskBudget) : null;
                                  const nearTask = pctTask !== null && pctTask >= 0.8 && pctTask < 1;
                                  const overTask = pctTask !== null && pctTask >= 1;
                                  return (
                                    <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                      <Chip size="small" label={`Previsto: ${formatCurrency(totals.previsto)}`} />
                                      <Chip size="small" label={`Real: ${formatCurrency(totals.real)}`} />
                                      {taskBudget > 0 && <Chip size="small" variant="outlined" label={`Budget tarefa: ${formatCurrency(taskBudget)}`} />}
                                      {pctTask !== null && <Chip size="small" color={overTask ? 'error' : (nearTask ? 'warning' : 'default')} label={`${Math.round(pctTask * 100)}% do budget da tarefa`} />}
                                      {projectBudget > 0 && <Chip size="small" variant="outlined" label={`Budget projeto: ${formatCurrency(projectBudget)}`} />}
                                    </Box>
                                  );
                                })()}
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Tooltip title="Ver tarefa"><IconButton aria-label="ver" onClick={() => openViewTask(task)}><VisibilityIcon /></IconButton></Tooltip>
                                <Tooltip title="Editar"><IconButton aria-label="editar" onClick={() => openEditTask(task)}><EditIcon /></IconButton></Tooltip>
                                <Tooltip title="Apagar"><IconButton aria-label="apagar" color="error" disabled={deletingTaskId === task.id} onClick={() => handleDeleteTask(task)}><DeleteIcon /></IconButton></Tooltip>
                              </Box>
                            </Box>
                            <Box sx={{ mt: 1 }}>
                              <TextField 
                                fullWidth 
                                multiline 
                                minRows={6}
                                label="Notas"
                                value={executionNotes[task.id] ?? task.notes ?? ''}
                                onChange={(e) => setExecutionNotes((prev) => ({ ...prev, [task.id]: e.target.value }))}
                                onBlur={() => handleSaveTaskNote(task)}
                                placeholder="Registe apontamentos de execução, bloqueios ou decisões."
                              />
                              {(Array.isArray(task.attachments) && task.attachments.length > 0) && (
                                <Box sx={{ mt: 1 }}>
                                  <Typography variant="body2" sx={{ mb: 1 }}>Documentos da tarefa:</Typography>
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                                    {(Array.isArray(task.attachments) ? task.attachments : []).map((u, ai) => (
                                      <Box key={`att-${task.id}-${ai}`} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Button variant="outlined" size="small" href={`${getApiHost()}${u}`} target="_blank" rel="noreferrer" startIcon={<DownloadIcon />}>{u.split('/').pop()}</Button>
                                        <Tooltip title="Remover documento">
                                          <IconButton size="small" color="error" onClick={() => handleRemoveTaskAttachment(task, u)}>
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                    ))}
                                  </Box>
                                </Box>
                              )}
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            {(Array.isArray(task.outputs) && task.outputs.length > 0) && (
                              <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                  <Typography variant="body2">Outputs</Typography>
                                </Box>
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 1 }}>
                                  {(Array.isArray(task.outputs) ? task.outputs : []).map((o, i) => (
                                    <Card key={`out-${task.id}-${i}`} variant="outlined">
                                      <CardContent sx={{ p: 1.5 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                          <Typography variant="body2" fontWeight={600}>{o.name || '—'}</Typography>
                                          <Tooltip title="Adicionar documento">
                                            <IconButton component="label" size="small">
                                              <AttachFileIcon fontSize="small" />
                                              <input type="file" multiple hidden onChange={(e) => handleQuickUploadOutputDocument(task, i, e)} />
                                            </IconButton>
                                          </Tooltip>
                                          <Chip size="small" label={(o.status || 'pendente') === 'concluido' ? 'Concluído' : 'A concluir'} color={(o.status || 'pendente') === 'concluido' ? 'success' : 'warning'} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                          {(o.startDate ? formatDateStr(o.startDate) : '—')} — {(o.endDate ? formatDateStr(o.endDate) : '—')}
                                        </Typography>
                                        {o.assignedTo && (
                                          <Box sx={{ mt: 0.5 }}>
                                            <Chip size="small" label={`Atribuído: ${o.assignedTo}`} variant="outlined" />
                                          </Box>
                                        )}
                                        {o.description && (
                                          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                            {o.description}
                                          </Typography>
                                        )}
                                        <Box sx={{ display: 'flex', gap: 1, mt: 0.75 }}>
                                          <Chip size="small" variant="outlined" label={`Previsto: ${formatCurrency(parseFloat(o.plannedValue) || 0)}`} />
                                          <Chip size="small" variant="outlined" label={`Real: ${formatCurrency(parseFloat(o.actualValue) || 0)}`} />
                                        </Box>
                                        {Array.isArray(o.documents) && o.documents.length > 0 && (
                                          <Box sx={{ mt: 1, display: 'grid', gridTemplateColumns: '1fr auto', rowGap: 0.5, columnGap: 1 }}>
                                            {(o.documents || []).map((d, di) => {
                                              const urlStr = typeof d === 'string' ? d : (d?.url || '');
                                              const name = urlStr.split('/').pop();
                                              return (
                                                <React.Fragment key={`out-doc-exec-${task.id}-${i}-${di}`}>
                                                  <Button variant="text" size="small" href={`${getApiHost()}${urlStr}`} target="_blank" rel="noreferrer" startIcon={<DownloadIcon />}>{name}</Button>
                                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                    <Tooltip title="Remover documento">
                                                      <IconButton size="small" color="error" onClick={() => handleRemoveOutputDocument(task, i, urlStr)}>
                                                        <DeleteIcon fontSize="small" />
                                                      </IconButton>
                                                    </Tooltip>
                                                  </Box>
                                                </React.Fragment>
                                              );
                                            })}
                                          </Box>
                                        )}
                                      </CardContent>
                                    </Card>
                                  ))}
                                </Box>
                              </Box>
                            )}
                          </Grid>
                        </Grid>
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </Grid>

              

              {/* Visualização tipo Gantt (simplificada) */}
              {scheduleTasks.length > 0 && (
                <Grid item xs={12}>
                  <Paper sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="subtitle1" gutterBottom>Visualização (Gantt simplificado)</Typography>
                      <Button size="small" variant="outlined" onClick={() => setGanttFullscreenOpen(true)}>Abrir em Página Inteira</Button>
                    </Box>
                    {(() => {
                      const bounds = getTimelineBounds();
                      if (!bounds) return <Typography color="textSecondary">Defina datas de início e fim nas tarefas para ver a linha do tempo.</Typography>;
                      const { min, max, days } = bounds;
                      return (
                        <Box sx={{ position: 'relative', border: '1px solid #ddd', borderRadius: 1, p: 1, overflowX: 'auto' }}>
                          <Box sx={{ position: 'relative', minWidth: '600px', height: (scheduleTasks.length * 36) + 24 }}>
                            {scheduleTasks.map((task, idx) => {
                              const s = toDate(task.startDate);
                              const e = toDate(task.endDate);
                              if (!s || !e || e < s) return null;
                              const left = (diffDays(min, s) / days) * 100;
                              const width = (diffDays(s, e) / days) * 100;
                              return (
                                <Box key={idx} sx={{ position: 'absolute', left: `${left}%`, top: (idx * 36) + 8, width: `${width}%`, height: 24, backgroundColor: '#36A2EB', borderRadius: 1 }}>
                                  <Box sx={{ position: 'absolute', left: 4, top: -18, fontSize: 12, color: '#555' }}>{task.name}</Box>
                                  <Box sx={{ position: 'absolute', right: 6, top: 2, fontSize: 12, color: '#fff' }}>{(() => {
                                    const s = task.status || 'planeado';
                                    switch (s) {
                                      case 'planeado': return 'Planeado';
                                      case 'em_execucao': return 'Em Execução';
                                      case 'concluido': return 'Concluído';
                                      case 'cancelado': return 'Cancelado';
                                      default: return '—';
                                    }
                                  })()}</Box>
                                </Box>
                              );
                            })}
                          </Box>
                        </Box>
                      );
                    })()}
                  </Paper>
                </Grid>
              )}
            </Grid>
          </Box>
        )}

        {/* Tab de Planeamento */}
        {tabValue === 0 && (
          <Box sx={{ p: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Âmbito
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    disabled={!isPlanningEditing}
                    value={projectDraft.scope}
                    onChange={(e) => setProjectDraft((p) => ({ ...p, scope: e.target.value }))}
                    placeholder="Defina o âmbito do projeto"
                    error={Boolean(validationErrors.scope)}
                    helperText={validationErrors.scope}
                  />
                </Paper>
              </Grid>
              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Objetivos
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    disabled={!isPlanningEditing}
                    value={projectDraft.objectives}
                    onChange={(e) => setProjectDraft((p) => ({ ...p, objectives: e.target.value }))}
                    placeholder="Liste os objetivos do projeto"
                    error={Boolean(validationErrors.objectives)}
                    helperText={validationErrors.objectives}
                  />
                </Paper>
              </Grid>

              {/* Atividades Globais (secção completa movida para cima do Cronograma) */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Atividades Globais
                </Typography>
                <Paper sx={{ p: 2, mb: 2 }}>
                  <Typography variant="subtitle1" gutterBottom>
                    Adicionar nova atividade global
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Título"
                        value={newActivity.title}
                        required
                        error={Boolean(newActivityErrors.title)}
                        helperText={newActivityErrors.title || ''}
                        onChange={(e) => {
                          const next = { ...newActivity, title: e.target.value };
                          setNewActivity(next);
                          validateNewActivity(next);
                        }}
                      />
                    </Grid>
                    {/* Datas removidas para Atividade Global */}
                    <Grid item xs={12} md={12}>
                      <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        label="Descrição"
                        value={newActivity.description}
                        onChange={(e) => setNewActivity((na) => ({ ...na, description: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        label="Objetivos"
                        value={newActivity.objectivesText}
                        onChange={(e) => setNewActivity((na) => ({ ...na, objectivesText: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        label="Entregáveis"
                        value={newActivity.deliverablesText}
                        onChange={(e) => setNewActivity((na) => ({ ...na, deliverablesText: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="contained"
                          disabled={creatingActivity || !newActivity.title}
                          onClick={async () => {
                            try {
                              const errs = validateNewActivity(newActivity);
                              if (Object.keys(errs).length > 0) {
                                alert('Por favor, corrija os erros do formulário.');
                                return;
                              }
                              setCreatingActivity(true);
                              await ensureLogin();
                              await createActivity({
                                title: newActivity.title,
                                description: newActivity.description,
                                objectivesText: newActivity.objectivesText,
                                deliverablesText: newActivity.deliverablesText,
                                isGlobal: true,
                                projectId: Number(id),
                                phase: 'planning'
                              });
                              setNewActivity({ title: '', description: '', objectivesText: '', deliverablesText: '' });
                              setNewActivityErrors({});
                              const refreshed = await fetchProjectActivities(Number(id));
                              setActivities(Array.isArray(refreshed) ? refreshed : []);
                              alert('Atividade global criada.');
                            } catch (err) {
                              alert('Falha ao criar atividade global');
                            } finally {
                              setCreatingActivity(false);
                            }
                          }}
                        >
                          Adicionar Atividade Global
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
                <Paper sx={{ p: 0 }}>
                  <List>
                    {activities.filter((a) => Boolean(a.isGlobal)).map((activity) => (
                      <ListItem key={activity.id} divider
                        secondaryAction={
                          <Box>
                            <IconButton aria-label="ver" onClick={() => openViewActivity(activity)}>
                              <VisibilityIcon />
                            </IconButton>
                            <IconButton aria-label="editar" onClick={() => openEditActivity(activity)}>
                              <EditIcon />
                            </IconButton>
                            <IconButton aria-label="apagar" color="error" disabled={deletingActivityId === activity.id} onClick={() => handleDeleteActivity(activity)}>
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        }
                      >
                        <ListItemText primary={activity.title} />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </Grid>

              {/* Secção 'Equipa de Projeto' removida. Campos passam a existir por tarefa. */}

              {/* Secção de Tarefas movida para a tab Execução */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Tarefas do Cronograma
                </Typography>
                {/* Formulário de criação de tarefa (Planeamento) */}
                <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="subtitle1" gutterBottom>
                    Adicionar nova tarefa
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Nome da Tarefa"
                        value={newTask.name}
                        onChange={(e) => setNewTask((t) => ({ ...t, name: e.target.value }))}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        type="date"
                        label="Início"
                        InputLabelProps={{ shrink: true }}
                        value={newTask.startDate}
                        onChange={(e) => {
                          const val = e.target.value;
                          setNewTask((t) => ({ ...t, startDate: val }));
                          const s = val ? new Date(val) : null;
                          const eD = newTask.endDate ? new Date(newTask.endDate) : null;
                          setNewTaskErrors({ dateOrder: (s && eD && s > eD) ? 'Início deve ser anterior ou igual ao fim.' : '' });
                        }}
                        error={Boolean(newTaskErrors.dateOrder)}
                        helperText={newTaskErrors.dateOrder || ''}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        type="date"
                        label="Fim"
                        InputLabelProps={{ shrink: true }}
                        value={newTask.endDate}
                        onChange={(e) => {
                          const val = e.target.value;
                          setNewTask((t) => ({ ...t, endDate: val }));
                          const s = newTask.startDate ? new Date(newTask.startDate) : null;
                          const eD = val ? new Date(val) : null;
                          setNewTaskErrors({ dateOrder: (s && eD && s > eD) ? 'Início deve ser anterior ou igual ao fim.' : '' });
                        }}
                        error={Boolean(newTaskErrors.dateOrder)}
                        helperText={newTaskErrors.dateOrder || ''}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Orçamento da Tarefa (€)"
                        inputProps={{ step: '0.01' }}
                        value={newTask.budget}
                        onChange={(e) => setNewTask((t) => ({ ...t, budget: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Responsável"
                        value={newTask.responsible}
                        onChange={(e) => setNewTask((t) => ({ ...t, responsible: e.target.value }))}
                        placeholder="Nome ou email"
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField fullWidth select label="Estado" value={newTask.status} onChange={(e) => setNewTask((t) => ({ ...t, status: e.target.value }))}>
                        <MenuItem value="planeado">Planeado</MenuItem>
                        <MenuItem value="em_execucao">Em Execução</MenuItem>
                        <MenuItem value="concluido">Concluído</MenuItem>
                        <MenuItem value="cancelado">Cancelado</MenuItem>
                      </TextField>
                    </Grid>
                    {/* Campo de dependências removido conforme requisito */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Técnico de Operações"
                        value={newTask.tecnicoOperacoesText}
                        onChange={(e) => setNewTask((t) => ({ ...t, tecnicoOperacoesText: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Coordenador Técnico"
                        value={newTask.coordenadorTecnicoText}
                        onChange={(e) => setNewTask((t) => ({ ...t, coordenadorTecnicoText: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Formador/Consultor"
                        value={newTask.formadorConsultorText}
                        onChange={(e) => setNewTask((t) => ({ ...t, formadorConsultorText: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="contained"
                          onClick={handleAddTask}
                          disabled={!(newTask.name && newTask.startDate && newTask.endDate) || Boolean(newTaskErrors.dateOrder)}
                        >
                          Adicionar Tarefa
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
                <Paper elevation={1} sx={{ p: 2 }}>
                  {scheduleTasks.length === 0 && (
                    <Typography color="text.secondary">Nenhuma tarefa registada neste projeto.</Typography>
                  )}
                  {scheduleTasks.length > 0 && (
                    <List>
                      {scheduleTasks.map((task) => (
                        <ListItem key={task.id} divider secondaryAction={(
                          <Box>
                            <IconButton aria-label="ver" onClick={() => openViewTask(task)}>
                              <VisibilityIcon />
                            </IconButton>
                            <IconButton aria-label="editar" onClick={() => openEditTask(task)}>
                              <EditIcon />
                            </IconButton>
                          </Box>
                        )}>
                          <ListItemText 
                            primary={`${task.name} • ${formatDateStr(task.startDate)} — ${formatDateStr(task.endDate)}`}
                            secondary={`Responsável: ${task.responsible || '—'} | Estado: ${(() => {
                              const s = task.status || 'planeado';
                              switch (s) {
                                case 'planeado': return 'Planeado';
                                case 'em_execucao': return 'Em Execução';
                                case 'concluido': return 'Concluído';
                                case 'cancelado': return 'Cancelado';
                                default: return 'Desconhecido';
                              }
                            })()}`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Paper>
              </Grid>

              {/* Guardar individual removido; usamos guardar global no topo */}

              {/* Equipa de Projeto com papéis predefinidos (duplicado removido) */}
              {false && (
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Equipa de Projeto
                </Typography>
                <Paper sx={{ p: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Gestor de Projeto"
                        value={teamAssignments.gestorProjeto || ''}
                        onChange={(e) => setTeamAssignments((p) => ({ ...p, gestorProjeto: e.target.value ? parseInt(e.target.value, 10) : null }))}
                      >
                        <MenuItem value="">—</MenuItem>
                        {allUsers.map((u) => (
                          <MenuItem key={u.id} value={u.id}>{u.name || u.email}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Técnico de Operações"
                        value={teamAssignments.tecnicoOperacoes || ''}
                        onChange={(e) => setTeamAssignments((p) => ({ ...p, tecnicoOperacoes: e.target.value ? parseInt(e.target.value, 10) : null }))}
                      >
                        <MenuItem value="">—</MenuItem>
                        {allUsers.map((u) => (
                          <MenuItem key={u.id} value={u.id}>{u.name || u.email}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Coordenador Técnico"
                        value={teamAssignments.coordenadorTecnico || ''}
                        onChange={(e) => setTeamAssignments((p) => ({ ...p, coordenadorTecnico: e.target.value ? parseInt(e.target.value, 10) : null }))}
                      >
                        <MenuItem value="">—</MenuItem>
                        {allUsers.map((u) => (
                          <MenuItem key={u.id} value={u.id}>{u.name || u.email}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Formador/Consultor"
                        value={teamAssignments.formadorConsultor || ''}
                        onChange={(e) => setTeamAssignments((p) => ({ ...p, formadorConsultor: e.target.value ? parseInt(e.target.value, 10) : null }))}
                      >
                        <MenuItem value="">—</MenuItem>
                        {allUsers.map((u) => (
                          <MenuItem key={u.id} value={u.id}>{u.name || u.email}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    Estas atribuições são guardadas ao clicar em "Guardar" no topo da aba.
                  </Typography>
                </Paper>
              </Grid>
              )}

              {false && (
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Atividades Globais
                </Typography>
                {true && (
                  <Paper sx={{ p: 2, mb: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Adicionar nova atividade global
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Título"
                          value={newActivity.title}
                          required
                          error={Boolean(newActivityErrors.title)}
                          helperText={newActivityErrors.title || ''}
                          onChange={(e) => {
                            const next = { ...newActivity, title: e.target.value };
                            setNewActivity(next);
                            validateNewActivity(next);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          fullWidth
                          type="date"
                          label="Início"
                          InputLabelProps={{ shrink: true }}
                          value={newActivity.startDate}
                          required
                          error={Boolean(newActivityErrors.startDate || newActivityErrors.dateOrder)}
                          helperText={newActivityErrors.startDate || newActivityErrors.dateOrder || ''}
                          onChange={(e) => {
                            const next = { ...newActivity, startDate: e.target.value };
                            setNewActivity(next);
                            validateNewActivity(next);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          fullWidth
                          type="date"
                          label="Fim"
                          InputLabelProps={{ shrink: true }}
                          value={newActivity.endDate}
                          required
                          error={Boolean(newActivityErrors.endDate || newActivityErrors.dateOrder)}
                          helperText={newActivityErrors.endDate || newActivityErrors.dateOrder || ''}
                          onChange={(e) => {
                            const next = { ...newActivity, endDate: e.target.value };
                            setNewActivity(next);
                            validateNewActivity(next);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          label="Descrição"
                          value={newActivity.description}
                          onChange={(e) => setNewActivity((na) => ({ ...na, description: e.target.value }))}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          label="Objetivos"
                          value={newActivity.objectivesText}
                          onChange={(e) => setNewActivity((na) => ({ ...na, objectivesText: e.target.value }))}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          label="Entregáveis"
                          value={newActivity.deliverablesText}
                          onChange={(e) => setNewActivity((na) => ({ ...na, deliverablesText: e.target.value }))}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Button
                            variant="contained"
                            disabled={
                              creatingActivity ||
                              !newActivity.title ||
                              !newActivity.startDate ||
                              !newActivity.endDate ||
                              Boolean(newActivityErrors.dateOrder)
                            }
                            onClick={async () => {
                              try {
                                const errs = validateNewActivity(newActivity);
                                if (Object.keys(errs).length > 0) {
                                  alert('Por favor, corrija os erros do formulário.');
                                  return;
                                }
                                setCreatingActivity(true);
                                await ensureLogin();
                                await createActivity({
                                  title: newActivity.title,
                                  description: newActivity.description,
                                  objectivesText: newActivity.objectivesText,
                                  startDate: newActivity.startDate || null,
                                  endDate: newActivity.endDate || null,
                                  isGlobal: true,
                                  projectId: Number(id),
                                  phase: 'planning'
                                });
                                setNewActivity({ title: '', description: '', objectivesText: '', startDate: '', endDate: '' });
                                setNewActivityErrors({});
                                const refreshed = await fetchProjectActivities(Number(id));
                                setActivities(Array.isArray(refreshed) ? refreshed : []);
                                alert('Atividade global criada.');
                              } catch (err) {
                                alert('Falha ao criar atividade global');
                              } finally {
                                setCreatingActivity(false);
                              }
                            }}
                          >
                            Adicionar Atividade Global
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>
                )}
                <Paper sx={{ p: 0 }}>
                  <List>
                    {activities.filter((a) => Boolean(a.isGlobal)).map((activity) => (
                      <ListItem key={activity.id} divider
                        secondaryAction={
                          <Box>
                            <IconButton aria-label="ver" onClick={() => openViewActivity(activity)}>
                              <VisibilityIcon />
                            </IconButton>
                            <IconButton aria-label="editar" onClick={() => openEditActivity(activity)}>
                              <EditIcon />
                            </IconButton>
                            <IconButton aria-label="apagar" color="error" disabled={deletingActivityId === activity.id} onClick={() => handleDeleteActivity(activity)}>
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        }
                      >
                        <ListItemText primary={`${activity.title} • ${formatDateStr(activity.startDate)} — ${formatDateStr(activity.endDate)}`} />
                      </ListItem>
                    ))}
                    {activities.filter((a) => Boolean(a.isGlobal)).length === 0 && (
                      <ListItem>
                        <ListItemText primary="Nenhuma atividade global registada." />
                      </ListItem>
                    )}
                  </List>
                </Paper>
              </Grid>
              )}
            </Grid>
          </Box>
        )}
        
        {/* Tab de Atividades */}
        {false && (
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6">Atividades do Projeto</Typography>
            </Box>
            <Paper sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle1" gutterBottom>Adicionar nova atividade</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Título"
                    value={newActivity.title}
                    onChange={(e) => setNewActivity((na) => ({ ...na, title: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Início"
                    InputLabelProps={{ shrink: true }}
                    value={newActivity.startDate}
                    onChange={(e) => setNewActivity((na) => ({ ...na, startDate: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Fim"
                    InputLabelProps={{ shrink: true }}
                    value={newActivity.endDate}
                    onChange={(e) => setNewActivity((na) => ({ ...na, endDate: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    label="Descrição"
                    value={newActivity.description}
                    onChange={(e) => setNewActivity((na) => ({ ...na, description: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      disabled={creatingActivity || !newActivity.title}
                      onClick={async () => {
                        try {
                          setCreatingActivity(true);
                          await ensureLogin();
                          await createActivity({
                            title: newActivity.title,
                            description: newActivity.description,
                            startDate: newActivity.startDate || null,
                            endDate: newActivity.endDate || null,
                            projectId: Number(id),
                            phase: project?.status || 'planning'
                          });
                          setNewActivity({ title: '', description: '', startDate: '', endDate: '' });
                          const refreshed = await fetchProjectActivities(Number(id));
                          setActivities(Array.isArray(refreshed) ? refreshed : []);
                          alert('Atividade criada.');
                        } catch (e) {
                          alert('Erro ao criar atividade.');
                        } finally {
                          setCreatingActivity(false);
                        }
                      }}
                    >
                      Adicionar Atividade
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
            <Grid container spacing={2}>
              {activities.map((activity) => (
                <Grid item xs={12} key={activity.id}>
                  <Paper sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {activity.title}
                      </Typography>
                      <Box>
                        <Chip 
                          label={getStatusText(activity.phase)} 
                          size="small" 
                          sx={{ mr: 1, backgroundColor: getStatusColor(activity.phase), color: 'white' }}
                        />
                        <Chip 
                          label={getStatusText(activity.status)} 
                          size="small" 
                          sx={{ backgroundColor: getStatusColor(activity.status), color: 'white' }}
                        />
                      </Box>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          Período: {formatDateStr(activity.startDate)} a {formatDateStr(activity.endDate)}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box sx={{ width: '100%', mr: 1 }}>
                            <LinearProgress 
                              variant="determinate" 
                              value={activity.completionPercentage} 
                              sx={{ height: 8, borderRadius: 4 }}
                            />
                          </Box>
                          <Box sx={{ minWidth: 35 }}>
                            <Typography variant="body2" color="textSecondary">
                              {activity.completionPercentage}%
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        
        {/* Tab de Riscos */}
        {false && (
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6">
                Matriz de Riscos
              </Typography>
            </Box>
            <Grid container spacing={2}>
              {risks.map((risk) => (
                <Grid item xs={12} md={6} key={risk.id}>
                  <Card>
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        {risk.description}
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="textSecondary">
                            Probabilidade:
                          </Typography>
                          <Chip 
                            label={risk.probability === 'low' ? 'Baixa' : risk.probability === 'medium' ? 'Média' : 'Alta'} 
                            size="small" 
                            color={risk.probability === 'low' ? 'success' : risk.probability === 'medium' ? 'warning' : 'error'}
                            variant="outlined"
                            sx={{ mt: 0.5 }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="textSecondary">
                            Impacto:
                          </Typography>
                          <Chip 
                            label={risk.impact === 'low' ? 'Baixo' : risk.impact === 'medium' ? 'Médio' : 'Alto'} 
                            size="small" 
                            color={risk.impact === 'low' ? 'success' : risk.impact === 'medium' ? 'warning' : 'error'}
                            variant="outlined"
                            sx={{ mt: 0.5 }}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                          <Typography variant="body2" color="textSecondary">
                            Mitigação:
                          </Typography>
                          <Typography variant="body2">
                            {risk.mitigation}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                          <Typography variant="body2" color="textSecondary">
                            Status:
                          </Typography>
                          <Chip 
                            label={
                              risk.status === 'identified' ? 'Identificado' : 
                              risk.status === 'mitigated' ? 'Mitigado' : 
                              risk.status === 'occurred' ? 'Ocorrido' : 'Resolvido'
                            } 
                            size="small" 
                            color={
                              risk.status === 'identified' ? 'warning' : 
                              risk.status === 'mitigated' ? 'success' : 
                              risk.status === 'occurred' ? 'error' : 'info'
                            }
                            sx={{ mt: 0.5 }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        
        {/* Tab de Equipa */}
        {false && (
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6">
                Equipa do Projeto
              </Typography>
              <Button 
                variant="contained" 
                startIcon={<AddIcon />}
                size="small"
                onClick={handleAddTeamMember}
              >
                Adicionar Membro
              </Button>
            </Box>
            <Grid container spacing={2}>
              {team.map((member) => (
                <Grid item xs={12} sm={6} md={4} key={member.id}>
                  <Card>
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {member.name}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                        {member.email}
                      </Typography>
                      <Chip 
                        label={
                          member.role === 'admin' ? 'Administrador' : 'Gestor'
                        } 
                        size="small" 
                        color={
                          member.role === 'admin' ? 'error' : 'primary'
                        }
                        sx={{ mt: 1 }}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        
        {/* Tab de Cronograma */}
        {false && (
          <Box sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Cronograma do Projeto
            </Typography>
            <Paper sx={{ p: 2, mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Data de Início
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {formatDateStr(project.startDate)}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Data de Fim
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {formatDateStr(project.endDate)}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              Cronograma de Atividades
            </Typography>
            
            {activities.length === 0 ? (
              <Paper sx={{ p: 3, textAlign: 'center' }}>
                <Typography color="textSecondary">
                  Nenhuma atividade encontrada para este projeto.
                </Typography>
              </Paper>
            ) : (
              <Grid container spacing={2}>
                {activities
                  .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
                  .map((activity, index) => (
                  <Grid item xs={12} key={activity.id}>
                    <Paper sx={{ p: 2 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Typography variant="subtitle1" fontWeight="bold">
                            {activity.title}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {activity.description}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Início: {formatDateStr(activity.startDate)}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Fim: {formatDateStr(activity.endDate)}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <Chip 
                            label={getStatusText(activity.status)} 
                            size="small" 
                            sx={{ backgroundColor: getStatusColor(activity.status), color: 'white' }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: '100%', mr: 1 }}>
                              <LinearProgress 
                                variant="determinate" 
                                value={activity.completionPercentage || 0} 
                                sx={{ height: 8, borderRadius: 4 }}
                              />
                            </Box>
                            <Box sx={{ minWidth: 35 }}>
                              <Typography variant="body2" color="textSecondary">
                                {activity.completionPercentage || 0}%
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        )}

        {/* Tab de Documentos */}
        {false && (
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6">
                Documentos do Projeto
              </Typography>
              <Button 
                variant="contained" 
                startIcon={<AssessmentIcon />}
                size="small"
                onClick={handleGenerateReport}
              >
                Gerar Relatório
              </Button>
            </Box>
            <Grid container spacing={2}>
              {reports.map((report) => (
                <Grid item xs={12} sm={6} md={4} key={report.id}>
                  <Card>
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {report.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                        Criado em: {formatDateStr(report.createdAt)}
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                        <Chip 
                          label={
                            report.type === 'project_manual' ? 'Manual de Projeto' : 
                            report.type === 'project_sheet' ? 'Ficha de Projeto' : 
                            report.type === 'risk_matrix' ? 'Matriz de Risco' : 
                            report.type === 'intermediate_report' ? 'Relatório Intermédio' : 
                            report.type === 'final_report' ? 'Relatório Final' : 
                            'Relatório de Impacto'
                          } 
                          size="small" 
                          color="primary"
                          variant="outlined"
                        />
                        <IconButton color="primary">
                          <DownloadIcon />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      {/* Diálogo: Ver atividade global */}
      <Dialog open={Boolean(viewActivity)} onClose={() => setViewActivity(null)} fullWidth maxWidth="md">
        <DialogTitle>Ver Atividade Global</DialogTitle>
        <DialogContent dividers>
          {viewActivity && (
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">{viewActivity.title}</Typography>
              {/* Atividades globais não possuem datas */}
              {viewActivity.description && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2">Descrição</Typography>
                  <Typography variant="body2">{viewActivity.description}</Typography>
                </Box>
              )}
              <Grid container spacing={2} sx={{ mb: 2 }}>
                {viewActivity.objectivesText && (
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">Objetivos</Typography>
                    <Typography variant="body2">{viewActivity.objectivesText}</Typography>
                  </Grid>
                )}
                {viewActivity.deliverablesText && (
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">Entregáveis</Typography>
                    <Typography variant="body2">{viewActivity.deliverablesText}</Typography>
                  </Grid>
                )}
              </Grid>
              {viewActivity.tasksText && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2">Tarefas</Typography>
                  <Typography variant="body2">{viewActivity.tasksText}</Typography>
                </Box>
              )}
              {/* Entregáveis movidos para ao lado de Objetivos para um layout 50/50 */}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewActivity(null)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo: Editar atividade global */}
      <Dialog open={Boolean(editActivity)} onClose={() => setEditActivity(null)} fullWidth maxWidth="md">
        <DialogTitle>Editar Atividade Global</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Título"
                value={editDraft.title}
                onChange={(e) => setEditDraft((d) => ({ ...d, title: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              {/* Datas removidas para atividade global */}
            </Grid>
            <Grid item xs={12} md={3}>
              {/* Datas removidas para atividade global */}
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Descrição"
                value={editDraft.description}
                onChange={(e) => setEditDraft((d) => ({ ...d, description: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Objetivos"
                value={editDraft.objectivesText}
                onChange={(e) => setEditDraft((d) => ({ ...d, objectivesText: e.target.value }))}
              />
            </Grid>
            {/* Campo 'Tarefas' removido do editar de atividade global conforme pedido */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                multiline
                minRows={2}
                label="Entregáveis (texto)"
                value={editDraft.deliverablesText}
                onChange={(e) => setEditDraft((d) => ({ ...d, deliverablesText: e.target.value }))}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditActivity(null)}>Cancelar</Button>
          <Button variant="contained" onClick={handleSaveEditActivity}>Guardar</Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo: Ver Tarefa do Cronograma */}
      <Dialog open={Boolean(viewTask)} onClose={() => setViewTask(null)} fullWidth maxWidth="md">
        <DialogTitle>Ver Tarefa</DialogTitle>
        <DialogContent dividers>
          {viewTask && (
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">{viewTask.name}</Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                ID: {viewTask.id}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Período: {formatDateStr(viewTask.startDate)} — {formatDateStr(viewTask.endDate)}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2">Responsável</Typography>
                  <Typography variant="body2">{viewTask.responsible || '—'}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2">Estado</Typography>
                  <Typography variant="body2">{(() => {
                    const s = viewTask.status || 'planeado';
                    switch (s) {
                      case 'planeado': return 'Planeado';
                      case 'em_execucao': return 'Em Execução';
                      case 'concluido': return 'Concluído';
                      case 'cancelado': return 'Cancelado';
                      default: return 'Desconhecido';
                    }
                  })()}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2">Gestor de Projeto</Typography>
                  <Typography variant="body2">{projectManagerDisplay}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2">Técnico de Operações</Typography>
                  <Typography variant="body2">{viewTask.tecnicoOperacoesText || '—'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2">Coordenador Técnico</Typography>
                  <Typography variant="body2">{viewTask.coordenadorTecnicoText || '—'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2">Formador/Consultor</Typography>
                  <Typography variant="body2">{viewTask.formadorConsultorText || '—'}</Typography>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewTask(null)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo: Editar Tarefa do Cronograma */}
      <Dialog open={Boolean(editTask)} onClose={() => setEditTask(null)} fullWidth maxWidth="md">
        <DialogTitle>Editar Tarefa</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField 
                fullWidth 
                label="Tarefa" 
                value={taskDraft.name} 
                onChange={(e) => setTaskDraft((d) => ({ ...d, name: e.target.value }))}
                InputProps={{
                  endAdornment: editTask?.id ? (
                    <InputAdornment position="end">
                      <Typography variant="caption" color="text.secondary">ID: {editTask.id}</Typography>
                    </InputAdornment>
                  ) : null
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Responsável" value={taskDraft.responsible} onChange={(e) => setTaskDraft((d) => ({ ...d, responsible: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField fullWidth type="date" label="Início" InputLabelProps={{ shrink: true }} value={taskDraft.startDate} onChange={(e) => {
                const val = e.target.value;
                setTaskDraft((d) => ({ ...d, startDate: val }));
                const s = val ? new Date(val) : null;
                const eD = taskDraft.endDate ? new Date(taskDraft.endDate) : null;
                setTaskEditErrors({ dateOrder: (s && eD && s > eD) ? 'Data de início deve ser anterior ou igual à data de fim.' : '' });
              }} />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField fullWidth type="date" label="Fim" InputLabelProps={{ shrink: true }} value={taskDraft.endDate} onChange={(e) => {
                const val = e.target.value;
                setTaskDraft((d) => ({ ...d, endDate: val }));
                const s = taskDraft.startDate ? new Date(taskDraft.startDate) : null;
                const eD = val ? new Date(val) : null;
                setTaskEditErrors({ dateOrder: (s && eD && s > eD) ? 'Data de início deve ser anterior ou igual à data de fim.' : '' });
              }} />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField fullWidth type="number" label="Orçamento da Tarefa (€)" inputProps={{ step: '0.01' }} value={taskDraft.budget} onChange={(e) => setTaskDraft((d) => ({ ...d, budget: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth select label="Estado" value={taskDraft.status || 'planeado'} onChange={(e) => {
                const val = e.target.value;
                setTaskDraft((d) => ({ ...d, status: val }));
              }}>
                <MenuItem value="planeado">Planeado</MenuItem>
                <MenuItem value="em_execucao">Em Execução</MenuItem>
                <MenuItem value="concluido">Concluído</MenuItem>
                <MenuItem value="cancelado">Cancelado</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Técnico de Operações" value={taskDraft.tecnicoOperacoesText || ''} onChange={(e) => setTaskDraft((d) => ({ ...d, tecnicoOperacoesText: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Coordenador Técnico" value={taskDraft.coordenadorTecnicoText || ''} onChange={(e) => setTaskDraft((d) => ({ ...d, coordenadorTecnicoText: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Formador/Consultor" value={taskDraft.formadorConsultorText || ''} onChange={(e) => setTaskDraft((d) => ({ ...d, formadorConsultorText: e.target.value }))} />
            </Grid>
            {tabValue === 1 && (
              <Grid item xs={12}>
                <TextField 
                  fullWidth 
                  multiline 
                  minRows={3}
                  label="Notas" 
                  value={taskDraft.notes || ''} 
                  onChange={(e) => setTaskDraft((d) => ({ ...d, notes: e.target.value }))} 
                  placeholder="Campo de texto livre para apontamentos da tarefa"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>Outputs</Typography>
              {(!Array.isArray(outputsDraft) || outputsDraft.length === 0) && (
                <Typography color="text.secondary">Sem outputs. Adicione abaixo.</Typography>
              )}
              {Array.isArray(outputsDraft) && outputsDraft.map((o, idx) => (
                <Card key={`edit-out-${idx}`} variant="outlined" sx={{ mb: 2 }}>
                  <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <TextField size="small" fullWidth label="Nome" value={o.name || ''} error={Boolean(outputsErrors[idx]?.name)} helperText={outputsErrors[idx]?.name || ''} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, name: e.target.value } : x);
                        setOutputsDraft(next);
                        const err = validateOutputRow(next[idx], taskDraft?.endDate);
                        setOutputsErrors((prev) => prev.map((ee, i) => i === idx ? err : ee));
                      }} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField size="small" fullWidth label="Descrição" value={o.description || ''} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, description: e.target.value } : x);
                        setOutputsDraft(next);
                      }} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField size="small" fullWidth label="Atribuído a" value={o.assignedTo || ''} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, assignedTo: e.target.value } : x);
                        setOutputsDraft(next);
                      }} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField size="small" fullWidth type="date" label="Início" InputLabelProps={{ shrink: true }} value={o.startDate || ''} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, startDate: e.target.value } : x);
                        setOutputsDraft(next);
                        const err = validateOutputRow(next[idx], taskDraft?.endDate);
                        setOutputsErrors((prev) => prev.map((ee, i) => i === idx ? err : ee));
                      }} error={Boolean(outputsErrors[idx]?.dateOrder)} helperText={outputsErrors[idx]?.dateOrder || ''} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField size="small" fullWidth type="date" label="Fim" InputLabelProps={{ shrink: true }} value={o.endDate || ''} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, endDate: e.target.value } : x);
                        setOutputsDraft(next);
                        const err = validateOutputRow(next[idx], taskDraft?.endDate);
                        setOutputsErrors((prev) => prev.map((ee, i) => i === idx ? err : ee));
                      }} error={Boolean(outputsErrors[idx]?.dateOrder)} helperText={outputsErrors[idx]?.dateOrder || ''} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField size="small" fullWidth label="Previsto" type="number" inputProps={{ step: '0.01' }} value={o.plannedValue || ''} error={Boolean(outputsErrors[idx]?.plannedValue)} helperText={outputsErrors[idx]?.plannedValue || ''} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, plannedValue: e.target.value } : x);
                        setOutputsDraft(next);
                        const err = validateOutputRow(next[idx], taskDraft?.endDate);
                        setOutputsErrors((prev) => prev.map((ee, i) => i === idx ? err : ee));
                      }} InputProps={{ startAdornment: <InputAdornment position="start">€</InputAdornment> }} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField size="small" fullWidth label="Real" type="number" inputProps={{ step: '0.01' }} value={o.actualValue || ''} error={Boolean(outputsErrors[idx]?.actualValue)} helperText={outputsErrors[idx]?.actualValue || ''} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, actualValue: e.target.value } : x);
                        setOutputsDraft(next);
                        const err = validateOutputRow(next[idx], taskDraft?.endDate);
                        setOutputsErrors((prev) => prev.map((ee, i) => i === idx ? err : ee));
                      }} InputProps={{ startAdornment: <InputAdornment position="start">€</InputAdornment> }} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField size="small" fullWidth select label="Estado" value={o.status || 'pendente'} onChange={(e) => {
                        const next = outputsDraft.map((x, i) => i === idx ? { ...x, status: e.target.value } : x);
                        setOutputsDraft(next);
                        const err = validateOutputRow(next[idx], taskDraft?.endDate);
                        setOutputsErrors((prev) => prev.map((ee, i) => i === idx ? err : ee));
                      }}>
                        <MenuItem value="pendente">A concluir</MenuItem>
                        <MenuItem value="concluido">Concluído</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>Documentos</Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                        {(Array.isArray(o.documents) ? [...o.documents].sort((a, b) => {
                          const sa = typeof a === 'string' ? a : (a?.url || '');
                          const sb = typeof b === 'string' ? b : (b?.url || '');
                          return String(sa.split('/').pop() || '').localeCompare(String(sb.split('/').pop() || ''));
                        }) : []).map((d, di) => (
                          <Box key={`out-doc-${idx}-${di}`} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Button variant="text" size="small" href={`${getApiHost()}${typeof d === 'string' ? d : d?.url}`} target="_blank" rel="noreferrer" startIcon={<DownloadIcon />}>{(typeof d === 'string' ? d : d?.url || '').split('/').pop()}</Button>
                            <Tooltip title="Remover documento">
                              <IconButton size="small" color="error" onClick={async () => {
                                const urlStr = typeof d === 'string' ? d : (d?.url || '');
                                if (!urlStr) return;
                                try {
                                  const rel = urlStr.replace(`${getApiHost()}`, '');
                                  await deleteStorage(Number(id), rel);
                                } catch {}
                                setOutputsDraft((prev) => prev.map((x, i) => i === idx ? { ...x, documents: (Array.isArray(x.documents) ? x.documents.filter((dd) => {
                                  const val = typeof dd === 'string' ? dd : (dd?.url || '');
                                  return val !== urlStr;
                                }) : []) } : x));
                              }}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ))}
                      </Box>
                      <Button variant="outlined" size="small" component="label" startIcon={<AttachFileIcon />}>
                        Adicionar documento
                        <input type="file" multiple hidden onChange={async (e) => {
                          const files = Array.from(e.target.files || []);
                          if (!files.length || !editTask?.id) return;
                          try {
                            await ensureLogin();
                            const relPath = `tasks/${editTask.id}/outputs/${idx}`;
                            const uploaded = await uploadStorage(Number(id), relPath, files);
                            const list = Array.isArray(uploaded) ? uploaded : (uploaded?.files || []);
                            const urls = list.map(u => ({ url: (u.url || u.path), uploadedAt: new Date().toISOString() })).filter(d => !!d.url);
                            setOutputsDraft((prev) => prev.map((x, i) => i === idx ? { ...x, documents: [...(Array.isArray(x.documents) ? x.documents : []), ...urls] } : x));
                            e.target.value = '';
                          } catch {}
                        }} />
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button color="error" variant="outlined" onClick={() => {
                        setOutputsDraft((prev) => prev.filter((_, i) => i !== idx));
                        setOutputsErrors((prev) => prev.filter((_, i) => i !== idx));
                      }}>Remover</Button>
                    </Grid>
                  </Grid>
                  </CardContent>
                </Card>
              ))}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => {
                  setOutputsDraft((prev) => [...prev, { name: '', description: '', assignedTo: '', startDate: '', endDate: '', plannedValue: '', actualValue: '', status: 'pendente' }]);
                  setOutputsErrors((prev) => [...prev, { name: 'Nome obrigatório.' }]);
                }}>Adicionar Output</Button>
              </Box>
            </Grid>
          </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setEditTask(null)}>Cancelar</Button>
        <Button variant="contained" onClick={handleSaveEditTask} disabled={Boolean(taskEditErrors.dateOrder) || (Array.isArray(outputsErrors) ? outputsErrors.some((e) => Object.keys(e || {}).length > 0) : false)}>Guardar</Button>
      </DialogActions>
      </Dialog>

      {/* Gantt em Página Inteira */}
      <Dialog open={ganttFullscreenOpen} onClose={() => setGanttFullscreenOpen(false)} fullScreen>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Gantt do Projeto</span>
        <Box>
          <TextField select size="small" value={ganttViewMode} onChange={(e) => {
            const mode = e.target.value;
            setGanttViewMode(mode);
            if (ganttInstanceRef.current) {
              ganttInstanceRef.current.change_view_mode(mode);
            }
          }} sx={{ mr: 2, minWidth: 140 }}>
            <MenuItem value="Quarter Day">Quarter Day</MenuItem>
            <MenuItem value="Half Day">Half Day</MenuItem>
            <MenuItem value="Day">Dia</MenuItem>
            <MenuItem value="Week">Semana</MenuItem>
            <MenuItem value="Month">Mês</MenuItem>
            <MenuItem value="Year">Ano</MenuItem>
          </TextField>
          <Button onClick={() => window.print()} sx={{ mr: 2 }}>Imprimir</Button>
          <Button onClick={async () => {
            if (!ganttContainerRef.current) return;
            const canvas = await html2canvas(ganttContainerRef.current);
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pageWidth;
            const imgHeight = (canvas.height * pageWidth) / canvas.width;
            const y = (pageHeight - imgHeight) / 2;
            pdf.addImage(imgData, 'PNG', 0, Math.max(0, y), imgWidth, imgHeight);
            pdf.save('gantt.pdf');
          }} sx={{ mr: 2 }}>Exportar PDF</Button>
          <Button variant="contained" onClick={() => setGanttFullscreenOpen(false)}>Fechar</Button>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ p: 2 }}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <TextField size="small" label="Pesquisar" value={ganttSearchText} onChange={(e) => setGanttSearchText(e.target.value)} fullWidth />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField size="small" label="Responsável" value={ganttResponsibleFilter} onChange={(e) => setGanttResponsibleFilter(e.target.value)} fullWidth />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField size="small" label="Atribuído a (output)" value={ganttAssignedToFilter} onChange={(e) => setGanttAssignedToFilter(e.target.value)} fullWidth />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel control={<Checkbox checked={ganttShowOutputs} onChange={(e) => setGanttShowOutputs(e.target.checked)} />} label="Mostrar outputs" />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField size="small" select label="Estados (tarefas)" value={ganttStatusFilter} onChange={(e) => {
                  const val = e.target.value;
                  setGanttStatusFilter(val || '__all__');
                }} fullWidth>
                  <MenuItem value="__all__">Todos os estados</MenuItem>
                  <MenuItem value="planeado">Planeado</MenuItem>
                  <MenuItem value="em_execucao">Em Execução</MenuItem>
                  <MenuItem value="concluido">Concluído</MenuItem>
                  <MenuItem value="cancelado">Cancelado</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField size="small" select label="Estado (outputs)" value={ganttOutputStateFilter} onChange={(e) => {
                  const val = e.target.value;
                  setGanttOutputStateFilter(val || '__all__');
                }} fullWidth>
                  <MenuItem value="__all__">Todos os estados</MenuItem>
                  <MenuItem value="pendente">A concluir</MenuItem>
                  <MenuItem value="concluido">Concluído</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField size="small" type="number" label="Previsto min" value={ganttPlannedMin} onChange={(e) => setGanttPlannedMin(e.target.value)} fullWidth />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField size="small" type="number" label="Previsto max" value={ganttPlannedMax} onChange={(e) => setGanttPlannedMax(e.target.value)} fullWidth />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField size="small" type="number" label="Real min" value={ganttRealMin} onChange={(e) => setGanttRealMin(e.target.value)} fullWidth />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField size="small" type="number" label="Real max" value={ganttRealMax} onChange={(e) => setGanttRealMax(e.target.value)} fullWidth />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField size="small" type="date" label="De" InputLabelProps={{ shrink: true }} value={ganttDateRange.start} onChange={(e) => setGanttDateRange((p) => ({ ...p, start: e.target.value }))} fullWidth />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField size="small" type="date" label="Até" InputLabelProps={{ shrink: true }} value={ganttDateRange.end} onChange={(e) => setGanttDateRange((p) => ({ ...p, end: e.target.value }))} fullWidth />
              </Grid>
              <Grid item xs={12} md={6}>
                <Button onClick={() => setGanttHiddenIds(new Set())}>Mostrar Tudo</Button>
              </Grid>
            </Grid>
          </Paper>
          <style>{`
            .bar-task-planeado .bar { fill: #607D8B; }
            .bar-task-em_execucao .bar { fill: #1976D2; }
            .bar-task-concluido .bar { fill: #2E7D32; }
            .bar-task-cancelado .bar { fill: #D32F2F; }
            .bar-output-pendente .bar { fill: #FFA000; }
            .bar-output-concluido .bar { fill: #2E7D32; }
            .details-container { font-size: 12px; padding: 6px; }
          `}</style>
          {/* CSS base do Frappe Gantt */}
          <link rel="stylesheet" href="https://unpkg.com/frappe-gantt/dist/frappe-gantt.css" />
          <div ref={ganttContainerRef} style={{ width: '100%', height: '72vh' }} />
          {ganttError && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>{ganttError}</Typography>
          )}
        </Box>
      </DialogContent>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSnackbar((s) => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Removido: Templates Drawer (substituído por página dedicada em /templates) */}

      </Box>
    </Box>
  );
};

export default ProjectDetails;
